(function() {
  var collectionsWithNoFilters = [];
  var applyFILTzOnSearch = true;

  var FJJParams = {
    common_elements: {
      starting_html_element:
        '<div class="refinement-item-wrap"><div class="@header_name filter-box refinement-header">@header_name</div><div class="refinement-body">',
      parent_starting_html_element:
        '<ul class="refinement-nav filtzgroup @p_class" data-title="@header_name" title="@header_name" group="@header_count">',
      parent_ending_html_element: "</ul>",
      ending_html_element: "</div></div>",
      sub_menu_html_element:
        '<li class="refinement-nav__item filtzoption @c_class" style="cursor:pointer;" group="@header_count" filter="@menu_key" title="Products with @header_name : @menu_name" state=0><a href="#">@menu_name @count_placing</a></li>'
    },
    // custom_side_bar_html: {
    //   product_type: {
    //     starting_html_element:
    //       '<div class="filter-wrapper test-2-class"><div class="@header_name filter-box"><div class="filter-header"><h3>@header_name</h3></div><div class="filter-body">',
    //     parent_starting_html_element:
    //       '<ul class="designFiltList filtzgroup @p_class" data-title="@header_name" title="@header_name" group="@header_count">',
    //     parent_ending_html_element: "</ul>",
    //     ending_html_element: "</div></div></div>",
    //     sub_menu_html_element:
    //       '<li class="filtzoption @c_class" group="@header_count" filter="@menu_key" title="Products with @header_name : @menu_name" state=0>@menu_name @count_placing</li>'
    //   }
    // },
    side_bar_element: "#side_bar_div_",
    products_loading_element: "#products-loading-div",
    products_processing_element: "#products-loading-template",
    show_count: false,
    count_element:
      '<span class="@count_class designTypeCount" style="color:grey;"></span>',
    pagination_element: ".filter-pagination",
    liquid_pagination_element: ".main-pagination",
    set_per_page: false,
    per_page_element: "#filtz_per_page",
    per_page_values: [12, 18, 24, 30, 60],
    set_sorting: true,
    sorting_element: "#SortBy",
    show_unavailable: true,
    // empty_filters				        : 'hide_main_menu',// hide_sub_menu_only
    toggle_class: "selected",
    //empty_element: "#filtz-empty",
    apply_show_more_less: false,
    pre_loader: "#filter-loading",
    active_filter: {
      show_filter: false,
      container: ".filtz-refine-selection",
      clear_all_ele: ".filtz-refine-clearall",
      af_place_holder: ".filtz_active_filters",
      af_ele:
        '<li class="filtz-refine-item filtz-remove-item" af_header="@af_header" af_value="@af_value"><a href="javascript:void(0);"><strong>@af_filter_header : </strong>@af_filter_value <span class="filtz-red-x">[X]</span></a></li>',
      close_btn_class: "filtz-remove-item"
    },
    ranges: {
      price: {
        header_name: "Price Range",
        header_key: "price",
        type: "price",
        sub_menu: [
          {
            menu_name: "Below $10",
            menu_key: "0-10"
          },
          {
            menu_name: "$10 - $20",
            menu_key: "10-20"
          },
          {
            menu_name: "$20 - $30",
            menu_key: "20-30"
          },
          {
            menu_name: "$30 - $40",
            menu_key: "30-40"
          },
          {
            menu_name: "$40 - $50",
            menu_key: "40-50"
          },
          {
            menu_name: "$50 - $100",
            menu_key: "50-100"
          },
          {
            menu_name: "$100 and above",
            menu_key: "100-@max_range"
          }
        ]
      }
    },
    menu_order: {
      collection: [],
      type: [],
      price: []
    },
    custom_headers: {"collection":"Series"},
    filter_menu_remove_options: ["size","color"],
    filter_menu_remove_tags: ["category", "age group"],
    filter_menu_remove_common: ["maxqty"],
    get_filters_from_tags: true,
    get_filters_from_options: true,
    display_show_more_hide: false,
    take_vendor: false,
    vendor_show_as: "Manufacturer",
    take_product_type: false,
    product_type_show_as: "Product Type",
    update_counter: {
      count_text: "<span>@count items found in @collection.</span>",
      count_element: ".items-found"
    },
    sub_menus_to_remove: {
      "Product Type": ["Cadet", "Bucket"],
      Color: ["Black"]
    }
  };


  this.removeFilterLoading = function() {
    let filterEle = document.getElementById("filter-loading");
    filterEle.parentNode.removeChild(filterEle);
    let filterElements = document.getElementsByClassName("filters");
    for (let i = 0; i < filterElements.length; i++) {
      filterElements[i].parentNode.removeChild(filterElements[i]);
    }
  };

  this.afterSidebarBuild = function() {
    $(document).on("click", ".view-more", function(e) {
      e.preventDefault();
      var thisClick = $(this);
      if (thisClick.text() == "View More >") {
        thisClick.text("View Less <");
        thisClick
          .closest(".filter-body")
          .find(".show-hide-group")
          .removeClass("hide");
      } else {
        thisClick.text("View More >");
        thisClick
          .closest(".filter-body")
          .find(".show-hide-group")
          .addClass("hide");
      }
    });

    $(document).on("click", ".color-swatch-wrap", function(e) {
      e.preventDefault();
      var newImg = $(this)
        .find("a")
        .attr("data-image");
      var productID = $(this)
        .find("a")
        .attr("data-product-id");
      var newHref = $(this)
        .find("a")
        .attr("href");
      $(this)
        .addClass("selectedSwatch")
        .siblings()
        .removeClass("selectedSwatch");

      $("img.productID" + productID).attr("srcset", newImg);
      $("a.productURL" + productID).attr("href", newHref);
    });

    $(document).on("click", ".filter-header", function(e) {
      e.preventDefault();
      let ele = $(this);
      ele.toggleClass("clicked");
      if (ele.hasClass("clicked")) {
        ele
          .closest(".filter-box")
          .addClass("active")
          .find(".filter-body")
          .hide();
      } else {
        ele
          .closest(".filter-box")
          .removeClass("active")
          .find(".filter-body")
          .show();
      }
    });
  };

  this.applyShowMoreLess = function() {
    $(".filtzgroup").each(function() {
      var thisGroup = $(this);
      if ($(this).find(".filtzoption").length > 7) {
        if ($(this).find(".view-more").length) {
        } else {
          thisGroup
            .parent()
            .append('<a href="" class="view-more">View More ></a>');
        }
        var counterOption = 1;
        thisGroup.find(".filtzoption").each(function() {
          if (counterOption > 7) {
            $(this).addClass("show-hide-group");
            $(this).addClass("hide");
          }
          counterOption++;
        });
      }
    });
  };

  this.afterFiltering = function(result) {};

  this.perPageChanged = function(productsPerPage) {};

  this.pageChanged = function(page) {};

  this.filterClicked = function(key, value, ele) {
    if (ele.attr("state") == 0) {
      ele.attr("state", 1);
    } else if (ele.attr("state") == 1) {
      ele.attr("state", 0);
    }
  };

  this.afterProductsDisplayed = function() {
    window._swat.initializeActionButtons('#products-loading-div');
  };

  /**
   * ========================
   * ==== Process Starts ====
   * ========================
   */

  this.devMode = false;

  var domLoaded = false,
    jQueryLoaded = false,
    resultsLoaded = false;

  if (devMode) {
    performance.mark("process-start");
    console.log(
      " -- Javascript intiated at " +
        performance.getEntriesByName("process-start")[0].startTime
    );
  }

  this.stateChecker = function() {
    if (devMode) {
      console.log(" -- StateChecker called ");
      console.log(" -- DOMLoaded " + domLoaded);
      console.log(" -- jQueryLoaded " + jQueryLoaded);
      console.log(" -- ResultsLoaded " + resultsLoaded);
    }
    if (domLoaded && jQueryLoaded && resultsLoaded) {
      if (
        typeof startFILTz !== "undefined" &&
        typeof startFILTz == "function"
      ) {
        F.callFILTz();
      } else {
        if (devMode) {
          console.log(" -- startFILTz() is not yet initialized");
        }
        setTimeout(function() {
          stateChecker();
        }, 0);
      }
    }
  };

  document.addEventListener("DOMContentLoaded", function(event) {
    jQueryLoaded = true;
    domLoaded = true;
    if (devMode) {
      performance.mark("dom-loaded");
      console.log(
        " -- DOM ready at " +
          performance.getEntriesByName("dom-loaded")[0].startTime
      );
    }
    if (devMode) {
      performance.mark("jquery-loaded");
      console.log(
        " -- jQuery ready at " +
          performance.getEntriesByName("jquery-loaded")[0].startTime
      );
    }
    stateChecker();
  });

  this.errorCatcher = function(err) {
    console.log("=============== Error reported ===============");
    console.log(">>>> ", err);
    let functionName =
      arguments.length > 0 &&
      typeof arguments[1] !== "undefined" &&
      arguments[1] !== null
        ? arguments[1].toString()
        : false;
    if (functionName) {
      console.log("Error in function " + functionName);
    }
    for (var prop in err) console.log(prop + ": " + err[prop]);
    throw new Error("==========================================");
  };

  this.sortResults = function(prods, prop, asc) {
    let products = prods.sort(function(a, b) {
      if (asc) {
        return a[prop] > b[prop] ? 1 : a[prop] < b[prop] ? -1 : 0;
      } else {
        return b[prop] > a[prop] ? 1 : b[prop] < a[prop] ? -1 : 0;
      }
    });
    return products;
  };

  this.getTagFromUrl = function() {
    let pathName = decodeURIComponent(window.location.href);
    let tagURLs = pathName.split("collections/")[1];
    if (
      typeof tagURLs !== "undefined" &&
      tagURLs != "" &&
      typeof tagURLs != null
    ) {
      if (tagURLs.indexOf("?") !== -1) {
        let _params_ = tagURLs.split("?");
        if (
          typeof _params_[0] !== "undefined" &&
          typeof _params_[0] != null &&
          _params_[0] != ""
        ) {
          return _params_[0];
        }
      }
    }
    return "";
  };

  if (typeof debounce === undefined || typeof debounce != "function") {
    this.debounce = function(func, wait, immediate) {
      var timeout;
      return function() {
        var context = this,
          args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    };
  }

  this._typeof = function(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj &&
          typeof Symbol === "function" &&
          obj.constructor === Symbol &&
          obj !== Symbol.prototype
          ? "symbol"
          : typeof obj;
      };
    }
    return _typeof(obj);
  };

  // var subCollectionName = getTagFromUrl();
  var subCollectionName = '';

  this.startFILTz = function() {
    var self = this;
    if (devMode) {
      performance.mark("filtz-start");
      console.log(
        " -- startFILTz called at " +
          performance.getEntriesByName("filtz-start")[0].startTime
      );
    }

    self.currentData = [];
    self.goAhead = true;

    self.basicChecking = function(ele) {
      if (typeof ele !== undefined && ele != null && ele != "") {
        return true;
      }
      return false;
    };

    if (templateName == "search") {
      if (!applyFILTzOnSearch) {
        removeFilterLoading();
        self.goAhead = false;
      }
    } else if (templateName == "collection") {
      if (
        self.basicChecking(collectionsWithNoFilters) &&
        collectionsWithNoFilters.length > 0
      ) {
        if (collectionsWithNoFilters.indexOf(resultHandle) === -1) {
          removeFilterLoading();
          self.goAhead = false;
        }
      }
    }

    if (self.goAhead) {
      self.initiateProcess();
    }
  };

  var SF = startFILTz.prototype;

  SF.initiateProcess = function() {
    let self = this;

    if (
      self.basicChecking(resultCount) &&
      self.basicChecking(paginateProductsBy) &&
      self.basicChecking(resultHandle) &&
      self.basicChecking(shopUrl)
    ) {
      self.countOfData = resultCount;
      self.paginateBy = paginateProductsBy;
      self.handle = resultHandle;
      self.shopUrl = shopUrl;
      self.subCollectionName = self.basicChecking(subCollectionName)
        ? subCollectionName
        : false;
      if (templateName == "collection") {
        self.collectionOrder = self.basicChecking(defaultOrder)
          ? defaultOrder
          : "title-ascending";
      } else if (templateName == "search") {
        self.collectionOrder = self.basicChecking(defaultOrder)
          ? defaultOrder
          : "product";
      }

      self.noOfPages = Math.ceil(self.countOfData / self.paginateBy);
      if (templateName == "collection") {
        self.urlString = self.shopUrl + "/collections/" + self.handle;
        if (self.subCollectionName) {
          self.urlString += "/" + self.subCollectionName;
        }
      } else if (templateName == "search") {
        self.urlString =
          self.shopUrl +
          "/search?q=" +
          self.handle +
          "&type=" +
          self.collectionOrder +
          "&view=json";
      }

      self.finalData = {};
      self.totalCounter = self.countOfData;
      self.manualCounter = 0;
      self.bestSellingCounter = 0;
      self.usualCounter = 0;

      if (self.noOfPages <= 0) {
        removeFilterLoading();
        if (devMode) {
          console.log("Operation terminated due to zero results");
        }
      } else {
        self.initiateAjax();
      }
    }
  };

  SF.initiateAjax = function() {
    let self = this;

    if (devMode) {
      performance.mark("ajax-start");
      console.log(
        " -- Initiated ajax at " +
          performance.getEntriesByName("ajax-start")[0].startTime
      );
    }

    for (let m = 1; m <= self.noOfPages; m++) {
      (function(m) {
        if (templateName == "collection") {
          /**
           * Get data in best-selling order
           */
          let ajaxUl =
            self.urlString + "?view=json&page=" + m + "&sort_by=best-selling&randNum=" + new Date().getTime();
          let appendTo = "best-selling";
          self.dataRetriever(ajaxUl, appendTo, m, self.processResults2);

          /**
           * Get data in manual order
           */
          ajaxUl = self.urlString + "?view=json&page=" + m + "&sort_by=manual&randNum=" + new Date().getTime();
          appendTo = "manual";
          self.dataRetriever(ajaxUl, appendTo, m, self.processResults2);

          /**
           * Get data in default order
           */
          if (
            self.collectionOrder != "manual" &&
            self.collectionOrder != "best-selling"
          ) {
            ajaxUl =
              self.urlString +
              "?view=json&page=" +
              m +
              "&sort_by=" +
              self.collectionOrder + '&randNum=' + new Date().getTime();
            appendTo = self.collectionOrder;
            self.dataRetriever(ajaxUl, appendTo, m, self.processResults2);
          }
        } else if (templateName == "search") {
          let ajaxUl = self.urlString + "&page=" + m + "&randNum=" + new Date().getTime();;
          self.fetchSearchResults(ajaxUl, m);
        }
      })(m);
    }
  };

  SF.dataRetriever = function (pageUrl, appendTo, pageNum, callback) {
    let self = this;

    let xhr = new XMLHttpRequest();
    xhr.open("GET", pageUrl);
    xhr.setRequestHeader("Content-Type", "text/html; charset=utf-8");
    xhr.send();

    xhr.onload = function () {
    if (xhr.status != 200) {
    throw new Error("Error ${xhr.status}: ${xhr.statusText}");
    } else {
    self.processResults(xhr.responseText, appendTo, pageNum);
    }
    };

    xhr.onerror = function () {
    throw new Error("FILTz error : Unable to complete Ajax Request");
    };
    };
  SF.processResults = function(data, appendTo, pageNum) {
    let self = this;

    let parsedData = JSON.parse(data);
    if (self.basicChecking(parsedData)) {
      let pageIndex = parseInt(pageNum) - 1;
      let orderNum = 0;
      if (pageIndex > 0) {
        orderNum = parseInt(pageIndex * self.paginateBy);
      }
      parsedData.forEach(function(prod, index) {
        orderNum++;
        let prodId = prod.id;

        if (!self.finalData.hasOwnProperty(prodId)) {
          prod.ORD = 0;
          prod.BST = 0;
          prod.MNL = 0;
          self.finalData[prodId] = prod;
        }
        if (appendTo == "manual") {
          self.finalData[prodId].MNL = orderNum;
          self.manualCounter++;
        } else if (appendTo == "best-selling") {
          self.finalData[prodId].BST = orderNum;
          self.bestSellingCounter++;
        }
        if (appendTo == defaultOrder) {
          self.finalData[prodId].ORD = orderNum;
          self.usualCounter++;
        }
        if (index == parsedData.length - 1) {
          if (
            self.totalCounter == self.manualCounter &&
            self.totalCounter == self.bestSellingCounter &&
            self.totalCounter == self.usualCounter
          ) {
            self.convergeData();
          }
        } else if (parsedData.length == 0) {
          removeFilterLoading();
        }
      });
    }
  };

  SF.convergeData = function() {
    let self = this;

    if (devMode) {
      performance.mark("ajax-end");
      console.log(
        " -- Completed ajax at " +
          performance.getEntriesByName("ajax-end")[0].startTime
      );
    }

    let productHold = [];
    for (let m in self.finalData) {
      let curData = self.finalData[m];
      productHold.push(curData);
    }
    let prop = "T";
    let mode = true;

    switch (self.collectionOrder) {
      case "manual":
        prop = "MNL";
        mode = true;
        break;

      case "best-selling":
        prop = "BST";
        mode = true;
        break;

      case "price-ascending":
        prop = "P";
        mode = true;
        break;

      case "price-descending":
        prop = "P";
        mode = false;
        break;

      case "title-ascending":
        prop = "T";
        mode = true;
        break;

      case "title-descending":
        prop = "T";
        mode = false;
        break;

      case "created-descending":
        prop = "CAT";
        mode = true;
        break;

      case "created-ascending":
        prop = "CAT";
        mode = false;
        break;

      default:
        prop = "ORD";
        mode = true;
        break;
    }
    productHold = sortResults(productHold, prop, mode);

    self.currentData = productHold;
    resultsLoaded = true;
    stateChecker();
  };

  SF.fetchSearchResults = function(pageUrl, batchNum) {
    let self = this;

    let xhr = new XMLHttpRequest();
    xhr.open("GET", pageUrl);
    xhr.setRequestHeader("Content-Type", "text/html; charset=utf-8");
    xhr.send();

    xhr.onload = function() {
      if (xhr.status != 200) {
        throw new Error("Error ${xhr.status}: ${xhr.statusText}");
      } else {
        self.appendSearchResults(xhr.responseText, batchNum);
      }
    };

    xhr.onerror = function() {
      throw new Error("FILTz error : Unable to complete Ajax Request");
    };
  };

  SF.appendSearchResults = function(string, batchNum) {
    let self = this;

    let results = JSON.parse(string);
    if (results) {
      let resultNum = batchNum == 1 ? 1 : batchNum * paginateProductsBy;
      for (var m = 0; m < results.length; m++) {
        (function(m) {
          results[m]["ORD"] = resultNum;
          self.currentData.push(results[m]);
          if (m == results.length - 1) {
            if (self.currentData.length == self.countOfData) {
              self.applyLandingChanges();
            }
          }
          resultNum++;
        })(m);
      }
    }
  };

  SF.applyLandingChanges = function() {
    let self = this;

    self.currentData = sortResults(self.currentData, "ORD", true);

    if (
      typeof landingPageParams !== "undefined" &&
      landingPageParams !== null &&
      landingPageParams != ""
    ) {
      FJJParams = landingPageParams;
    }
    resultsLoaded = true;
    if (devMode) {
      performance.mark("ajax-end");
      console.log(
        " -- Completed ajax at " +
          performance.getEntriesByName("ajax-end")[0].startTime
      );
    }
    stateChecker();
  };

  SF.callFILTz = function() {
    var self = this;

    if (typeof FILTz !== "undefined" && typeof FILTz === "function") {
      if (devMode) {
        console.log(" -- Data fetched & going to start process");
      }
      let filtered = self.currentData.filter(function(el) {
        return el;
      });
      if (filtered.length == 0) {
        removeFilterLoading();
        if (devMode) {
          console.log(" -- Zero results, terminating process");
        }
      } else {
        FJJParams.data_info = filtered;
        var FIL = FILTz(FJJParams);
        showPerformance();
      }
    } else {
      setTimeout(function() {
        self.callFILTz();
      }, 0);
    }
  };

  this.F = new startFILTz();

  this.showPerformance = function() {
    if (devMode) {
      console.log("=========|| Performance Summary ||=========");
      var performanceKeys = [
        "DOM loading",
        "jQuery loading",
        "Ajax",
        "Total time till fetching results",
        "Sidebar Building",
        "Total time till Sidebar Build",
        "Total time of process"
      ];
      performance.measure(performanceKeys[0], "process-start", "dom-loaded");
      performance.measure(performanceKeys[1], "process-start", "jquery-loaded");
      performance.measure(performanceKeys[2], "ajax-start", "ajax-end");
      performance.measure(performanceKeys[3], "process-start", "ajax-end");
      performance.measure(performanceKeys[4], "sidebar-start", "sidebar-stop");
      performance.measure(performanceKeys[5], "process-start", "sidebar-stop");
      performance.measure(performanceKeys[6], "process-start", "process-stop");

      var items = window.performance.getEntriesByType("measure");
      for (var i = 0; i < items.length; ++i) {
        var req = items[i];
        if (performanceKeys.indexOf(req.name) !== -1) {
          console.log(
            "PROCESS- " + req.name + " took " + req.duration + " /ms"
          );
        }
      }

      console.log("===========================================");
    }
  };
})();

(function($, window, document, undefined) {
  var beforeAddRecords = function(result) {};

  var afterAddRecords = function(result) {};

  var beforeRender = function(result) {};

  var beforeRecordRender = function(result) {};

  var afterFilter = function(result, jQ) {
    FHL.afterFilter(result, jQ);
    afterFiltering(result);
  };

  function CommonProcedures() {
    "use strict";

    this.basicValidation = function(node, parent) {
      try {
        if (typeof node !== "undefined" && node !== null && node != "") {
          if (
            typeof parent !== "undefined" &&
            parent !== null &&
            parent != ""
          ) {
            if (
              node in parent &&
              typeof parent[node] !== "undefined" &&
              parent[node] != null &&
              parent[node] != ""
            ) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (ex) {
        errorCatcher(ex, "basicValidation");
      }
    };

    this.basicChecker = function(value) {
      try {
        return typeof value !== "undefined" && value != null && value != ""
          ? true
          : false;
      } catch (ex) {
        errorCatcher(ex, "basicChecker");
      }
    };

    this.splitAndTrim = function(str) {
      try {
        return str
          .toString()
          .trim()
          .split(" ")
          .join("_")
          .trim();
      } catch (ex) {
        errorCatcher(ex, "splitAndTrim");
      }
    };

    this.splitAndTrimAndReverse = function(str) {
      try {
        return str
          .toString()
          .trim()
          .split("_")
          .join(" ")
          .trim();
      } catch (ex) {
        errorCatcher(ex, "splitAndTrimAndReverse");
      }
    };

    this.splitAndTrimAndLower = function(str) {
      try {
        let temp = this.splitAndTrim(str);
        return temp.toLowerCase();
      } catch (ex) {
        errorCatcher(ex, "splitAndTrimAndLower");
      }
    };

    this.splitAndTrimOptions = function(str) {
      try {
        return str
          .toString()
          .trim()
          .split("/")
          .join("-")
          .split(" ")
          .join("_")
          .trim();
      } catch (ex) {
        errorCatcher(ex, "splitAndTrimOptions");
      }
    };

    this.splitAndTrimAndLowerOptions = function(str) {
      try {
        let temp = this.splitAndTrimOptions(str);
        return temp.toLowerCase();
      } catch (ex) {
        errorCatcher(ex, "splitAndTrimAndLowerOptions");
      }
    };

    this.trimAndLowerArray = function(arr) {
      try {
        return arr.map(function(x) {
          return x
            .toString()
            .trim()
            .split(" ")
            .join("_")
            .trim()
            .toLowerCase();
        });
      } catch (ex) {
        errorCatcher(ex, "trimAndLowerArray");
      }
    };

    this.errorHandler = function(err) {
      throw new Error(this.convertToString(err));
    };

    this.convertToString = function(e) {
      try {
        if (Array.isArray(e)) {
          return e.join(" , ");
        } else {
          if (typeof e === "string") {
            return e;
          } else if (_typeof(e) === "object") {
            return JSON.stringify(e);
          } else {
            return e;
          }
        }
      } catch (ex) {
        errorCatcher(ex, "convertToString");
      }
    };

    this.toTitleCase = function(str) {
      try {
        return str.toString().replace(/(?:^|\s)\w/g, function(match) {
          return match.toUpperCase();
        });
      } catch (ex) {
        errorCatcher(ex, "toTitleCase");
      }
    };

    this.compareArrays = function(a1, a2) {
      try {
        let a = [],
          diff = [];

        for (let i = 0; i < a1.length; i++) {
          a[a1[i]] = true;
        }

        for (let i = 0; i < a2.length; i++) {
          if (a[a2[i]]) {
            delete a[a2[i]];
          } else {
            a[a2[i]] = true;
          }
        }

        for (let k in a) {
          diff.push(k);
        }

        return diff;
      } catch (ex) {
        errorCatcher(ex, "compareArrays");
      }
    };

    this.stringReplace = function(str, src, rep) {
      try {
        if (_typeof(str) === "object") {
          str = JSON.stringify(str);
        }
        str = str.toString();
        str = str.split(src).join(rep);
        return str;
      } catch (ex) {
        errorCatcher(ex, "stringReplace");
      }
    };

    this.htmlToString = function(htmlEle) {
      try {
        let htmlStr = "";
        for (let m = 0; m < htmlEle.length; m++) {
          htmlStr += htmlEle[m]["outerHTML"];
        }
        return htmlStr;
      } catch (ex) {
        errorCatcher(ex, "htmlToString");
      }
    };

    /**
     * Perform a Schwartzian transform,
     * breaking each entry into pieces first
     */
    this.naturalSorter = function(ary, fullNumbers) {
      try {
        ary.filter(function(e) {
          return e;
        });
        ary.compact;

        let re = fullNumbers ? /[\d\.\-]+|\D+/g : /\d+|\D+/g;

        for (let i = ary.length; i--; ) {
          if (ary[i] !== undefined && ary[i] != null && ary[i] != "") {
            ary[i] = [ary[i]].concat(
              (ary[i] + "").match(re).map(function(s) {
                return isNaN(s) ? [s, false, s] : [s * 1, true, s];
              })
            );
          }
        }
        /**
         * Perform a cascading sort down the pieces
         */
        ary.sort(function(a, b) {
          let al = a.length,
            bl = b.length,
            e = al > bl ? al : bl;

          for (let i = 1; i < e; ++i) {
            // Sort "a" before "a1"
            if (i >= al) return -1;
            else if (i >= bl) return 1;
            else if (a[i][0] !== b[i][0])
              return a[i][1] && b[i][1] // Are we comparing numbers?
                ? a[i][0] - b[i][0] // Then diff them.
                : a[i][2] < b[i][2]
                ? -1
                : 1; // Otherwise, lexicographic sort
          }

          return 0;
        }); // Restore the original values into the array

        for (let i = ary.length; i--; ) {
          if (ary[i] !== undefined && ary[i] != null && ary[i] != "") {
            ary[i] = ary[i][0];
          }
        }
        // return ary.reverse();
        return ary;
      } catch (ex) {
        errorCatcher(ex, "naturalSorter");
      }
    };

    this.escaper = function(str) {
      try {
        let ret = str.replace(
          /([;&,\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g,
          "\\$1"
        );
        ret = ret.replace("/", "-");
        ret = ret.replace(/[^A-Z0-9]/gi, "_");
        return ret;
      } catch (ex) {
        errorCatcher(ex, "escaper");
      }
    };
  }

  let CP = new CommonProcedures();

  function InitiateFILTz(params) {
    "use strict";

    let self = this;

    this.params = params;

    this.parentClass = "hd_filtz_mnu";
    this.childClass = "sb_filtz_mnu";
    this.permanentToggleClass = "filter-active";
    this.initialProductsContainer = "default_hidden_product_loading_ele";
    this.filterHolder = {};
    this.filterAppliedCount = 0;
    this.ranges = {};
    this.orders = {};
    this.defaultFilterCountClass = "filtz__filter-counter";
    this.showCount = false;
    this.toggleClass = false;
    this.showSort = false;
    this.sortElement = false;
    this.showPerPage = false;
    this.perPageElement = false;
    this.perPageValues = [24];
    this.emptyElement = false;
    this.activeFilter = false;
    this.activeFilterObj = false;

    window.filtzParentClass = this.parentClass;
    window.filtzChildClass = this.childClass;

    let validateParameters = this.validateParameters();

    $.when(validateParameters).done(function() {
      let subMenuRemovals = self.setSubMenuRemovals();

      $.when(subMenuRemovals).done(function() {
        let commonRemovals = self.getCommonRemovals();

        $.when(commonRemovals).done(function() {
          let tagRemovals = self.getTagRemovals();

          $.when(tagRemovals).done(function() {
            let optionRemovals = self.getOptionRemovals();

            $.when(optionRemovals).done(function() {
              let checkingTags = self.checkTags();

              $.when(checkingTags).done(function() {
                let checkingOptions = self.checkOptions();

                $.when(checkingOptions).done(function() {
                  if (self.hasRanges) {
                    self.setRanges();
                  }
                  if (self.hasOrder) {
                    self.setMenuOrder();
                  }
                  let firstLoop = self.initiateFirstLoop();

                  $.when(firstLoop).done(function() {
                    let secondLoop = self.initiateSecondLoop();

                    $.when(secondLoop).done(function() {
                      self.finalOrder = self.reorderMenu();
                      let sideBarBuilded = self.buildSideBar();

                      $.when(sideBarBuilded).done(function() {
                        afterSidebarBuild();
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    });
  }

  var FL = InitiateFILTz.prototype;

  FL.validateParameters = function() {
    let self = this;

    if (devMode) {
      console.log(" -- Entering validateParameters");
    }
    let params = self.params;

    /**
     * Checking type of parameter
     */
    let parameterType = _typeof(params);
    if (parameterType != "object") {
      CP.errorHandler(
        "The parameters for FILTz must be an object. Supplied " +
          parameterType +
          " instead."
      );
    }

    /**
     * Checking product data
     */
    if (!CP.basicValidation("data_info", params)) {
      CP.errorHandler(
        "Please make sure you are providing the product's JSON data as 'data_info'."
      );
    }
    if (params.data_info.length == 0) {
      CP.errorHandler("No products are available in the data_info array.");
    }
    self.allProducts = params.data_info;

    /**
     * Checking sidebar
     */
    if (!CP.basicValidation("side_bar_element", params)) {
      CP.errorHandler(
        "No HTML element is given to append the sidebar. Please provide 'side_bar_element'."
      );
    }
    if ($(params.side_bar_element).length == 0) {
      CP.errorHandler("Cannot find an HTML element to append sidebar in DOM.");
    }
    self.sideBarElement = params.side_bar_element;

    /**
     * Checking pre loader
     */
    if (CP.basicValidation("pre_loader", params)) {
      if ($(params.pre_loader).length == 0) {
        CP.errorHandler("Cannot find pre loader in DOM.");
      }
      self.preLoader = params.pre_loader;
    }

    /**
     * Checking products loading element
     */
    if (!CP.basicValidation("products_loading_element", params)) {
      CP.errorHandler(
        "No HTML element is given to append the products. Please provide 'products_loading_element'."
      );
    }
    if ($(params.products_loading_element).length == 0) {
      CP.errorHandler(
        "Cannot find an HTML element to append the products in DOM."
      );
    }
    self.productsContainer = params.products_loading_element;

    /**
     * Checking product processing template
     */
    if (!CP.basicValidation("products_processing_element", params)) {
      CP.errorHandler(
        "No JS template is given to process the products. Please provide 'products_processing_element'."
      );
    }
    if ($(params.products_processing_element).length == 0) {
      CP.errorHandler(
        "Cannot find JS template to process the products in DOM."
      );
    }
    self.productsProcessor = params.products_processing_element;

    /**
     * Checking FILTz pagination element
     */
    if (!CP.basicValidation("pagination_element", params)) {
      CP.errorHandler("Require an HTML element for the FILTz pagination.");
    }
    if ($(params.pagination_element).length == 0) {
      CP.errorHandler("Cannot find the FILTz pagination element in DOM.");
    }
    self.filtzPaginationElement = params.pagination_element;

    /**
     * Setting liquid pagination element
     */
    self.liquidPaginationElement = params.liquid_pagination_element;

    /**
     * Setting Custom Headers
     */
    self.customHeaders = false;
    if (CP.basicValidation("custom_headers", params)) {
      self.customHeaders = params.custom_headers;
    }

    /**
     * Checking count for each filter
     */
    if (CP.basicValidation("show_count", params) && params.show_count == true) {
      self.showCount = true;
    }
    self.countElement = CP.basicValidation("count_element", params)
      ? params.count_element
      : '<span class="pr_count @count_class" style="color:grey;"></span>';

    /**
     * Checking products per page
     */
    if (
      CP.basicValidation("set_per_page", params) &&
      params.set_per_page == true
    ) {
      if (!CP.basicValidation("per_page_element", params)) {
        CP.errorHandler(
          "Require an HTML element for setting results per page. Please provide 'per_page_element'."
        );
      }
      if ($(params.per_page_element).length == 0) {
        CP.errorHandler(
          "Cannot find HTML elements for setting results per page in DOM."
        );
      }
      self.showPerPage = true;
      self.perPageElement = params.per_page_element;
      self.perPageValues =
        CP.basicValidation("per_page_values", params) &&
        params.per_page_values.length > 0
          ? params.per_page_values
          : [12, 15, 18, 20, 25, 30];
    } else {
      self.perPageElement = "#filtz__default-per-page-ele";
      $("body").append(
        '<span id="filtz__default-per-page-ele" style="display: none;"></span>'
      );
    }

    /**
     * Checking sorting
     */
    if (
      CP.basicValidation("set_sorting", params) &&
      params.set_sorting == true
    ) {
      if (!CP.basicValidation("sorting_element", params)) {
        CP.errorHandler(
          "Require an HTML element for sorting products. Please provide 'sorting_element'."
        );
      }
      if ($(params.sorting_element).length == 0) {
        CP.errorHandler(
          "Cannot find an HTML element for sorting results in DOM."
        );
      }
      self.showSort = true;
      self.sortElement = params.sorting_element;
    }

    /**
     * Checking empty element
     * to show when there are no products in the filter
     */
    // if (CP.basicValidation("empty_element", params)) {
    //   if ($(params.empty_element).length == 0) {
    //     CP.errorHandler(
    //       "Cannot find HTML elements when results become empty in DOM."
    //     );
    //   }
    //   self.emptyElement = this.params.empty_element;
    // }

    /**
     * Active filter / Selected filter
     */
    if (CP.basicValidation("active_filter", params)) {
      let afObj = params.active_filter;
      if (
        CP.basicValidation("show_filter", afObj) &&
        afObj.show_filter == true
      ) {
        if (!CP.basicValidation("container", afObj)) {
          CP.errorHandler(
            "Specify 'show_filter' inside 'active_filter' object."
          );
        }
        if ($(afObj.container).length == 0) {
          CP.errorHandler(
            "Cannot find HTML element for setting active filters in DOM."
          );
        }
        if (!CP.basicValidation("clear_all_ele", afObj)) {
          CP.errorHandler(
            "Specify 'clear_all_ele' inside 'active_filter' object."
          );
        }
        if ($(afObj.clear_all_ele).length == 0) {
          CP.errorHandler(
            "Cannot find HTML element for clearing all active filters in DOM."
          );
        }
        if (!CP.basicValidation("af_place_holder", afObj)) {
          CP.errorHandler(
            "Specify 'af_place_holder' inside 'active_filter' object."
          );
        }
        if (!CP.basicValidation("af_ele", afObj)) {
          CP.errorHandler("Specify 'af_ele' inside 'active_filter' object.");
        }
        if (!CP.basicValidation("close_btn_class", afObj)) {
          CP.errorHandler(
            "Specify 'close_btn_class' inside 'active_filter' object."
          );
        }
        self.activeFilter = true;
        self.activeFilterObj = {};
        self.activeFilterObj.container = afObj.container;
        self.activeFilterObj.clearAllElement = afObj.clear_all_ele;
        self.activeFilterObj.placeHolder = afObj.af_place_holder;
        self.activeFilterObj.element = afObj.af_ele;
        self.activeFilterObj.closeButtonClass = afObj.close_btn_class;
      }
    }

    /**
     * Checking the ranges
     */
    if (CP.basicValidation("ranges", params)) {
      self.hasRanges = true;
    }

    /**
     * Checking the menu order
     */
    if (CP.basicValidation("menu_order", params)) {
      self.hasOrder = true;
    }

    /**
     * Checking the html elements
     */
    if (!CP.basicValidation("common_elements", params)) {
      self.starting_html_element =
        '<div class="filter-wrapper"><div class="by-design filter-box"><div class="filter-header"><h3>@header_name</h3></div><div class="filter-body">';
      self.ending_html_element = "</div></div></div>";
      self.parent_starting_html_element =
        '<div class="filtzgroup @p_class" data-title="@header_name" title="@header_name" group="@header_count"><h4>@header_name</h4>';
      self.parent_ending_html_element = "</div>";
      self.sub_menu_html_element =
        '<div class="filtzoption @c_class" group="@header_count" filter="@menu_key" title="Products with @header_name : @menu_name" filtzstate=0>@menu_name @count_placing</div>';
    } else {
      if (
        !CP.basicValidation("starting_html_element", params.common_elements)
      ) {
        self.starting_html_element =
          '<div class="filter-wrapper"><div class="by-design filter-box"><div class="filter-header"><h3>@header_name</h3></div><div class="filter-body">';
      } else {
        self.starting_html_element =
          params.common_elements.starting_html_element;
      }
      if (!CP.basicValidation("ending_html_element", params.common_elements)) {
        self.ending_html_element = "</div></div></div>";
      } else {
        self.ending_html_element = params.common_elements.ending_html_element;
      }
      if (
        !CP.basicValidation(
          "parent_starting_html_element",
          params.common_elements
        )
      ) {
        self.parent_starting_html_element =
          '<div class="filtzgroup @p_class" data-title="@header_name" title="@header_name" group="@header_count"><h4>@header_name</h4>';
      } else {
        self.parent_starting_html_element =
          params.common_elements.parent_starting_html_element;
      }
      if (
        !CP.basicValidation(
          "parent_ending_html_element",
          params.common_elements
        )
      ) {
        self.parent_ending_html_element = "</div>";
      } else {
        self.parent_ending_html_element =
          params.common_elements.parent_ending_html_element;
      }
      if (
        !CP.basicValidation("sub_menu_html_element", params.common_elements)
      ) {
        self.sub_menu_html_element =
          '<div class="filtzoption @c_class" group="@header_count" filter="@menu_key" title="Products with @header_name : @menu_name" filtzstate=0>@menu_name @count_placing</div>';
      } else {
        self.sub_menu_html_element =
          params.common_elements.sub_menu_html_element;
      }
    }

    /**
     * Checking Custom Sidebar HTML
     */
    self.customSideBarHtml = {};
    if (
      CP.basicValidation("custom_side_bar_html", params) &&
      !jQuery.isEmptyObject(params.custom_side_bar_html)
    ) {
      for (let m in params.custom_side_bar_html) {
        if (
          CP.basicChecker(m) &&
          CP.basicChecker(params.custom_side_bar_html[m])
        ) {
          let sideBarKey = m;
          let sideBar = params.custom_side_bar_html[m];

          if (!CP.basicValidation("starting_html_element", sideBar)) {
            CP.errorHandler(
              "Specify 'starting_html_element' inside 'custom_side_bar_html' - " +
                m +
                " object."
            );
          }
          let startingHtmlEle = sideBar.starting_html_element;

          if (!CP.basicValidation("parent_starting_html_element", sideBar)) {
            CP.errorHandler(
              "Specify 'parent_starting_html_element' inside 'custom_side_bar_html' - " +
                m +
                " object."
            );
          }
          let parentStartingHtmlEle = sideBar.parent_starting_html_element;

          if (!CP.basicValidation("parent_ending_html_element", sideBar)) {
            CP.errorHandler(
              "Specify 'parent_ending_html_element' inside 'custom_side_bar_html' - " +
                m +
                " object."
            );
          }
          let parentEndingHtmlEle = sideBar.parent_ending_html_element;

          if (!CP.basicValidation("ending_html_element", sideBar)) {
            CP.errorHandler(
              "Specify 'ending_html_element' inside 'custom_side_bar_html' - " +
                m +
                " object."
            );
          }
          let endingHtmlEle = sideBar.ending_html_element;

          if (!CP.basicValidation("sub_menu_html_element", sideBar)) {
            CP.errorHandler(
              "Specify 'sub_menu_html_element' inside 'custom_side_bar_html' - " +
                m +
                " object."
            );
          }
          let subMenuHtmlEle = sideBar.sub_menu_html_element;

          let tempSideBarKey = CP.splitAndTrimAndLower(sideBarKey);
          let temp = {};
          let sideBarObj = {
            starting_html_element: startingHtmlEle,
            parent_starting_html_element: parentStartingHtmlEle,
            parent_ending_html_element: parentEndingHtmlEle,
            ending_html_element: endingHtmlEle,
            sub_menu_html_element: subMenuHtmlEle
          };
          temp[tempSideBarKey] = sideBarObj;
          $.extend(self.customSideBarHtml, temp);
        }
      }
    }

    /**
     * Checking the toggle class on filter on/off
     */
    if (CP.basicValidation("toggle_class", params)) {
      self.toggleClass = params.toggle_class;
    }

    /**
     * Checking apply show more/less property
     */
    if (
      CP.basicValidation("apply_show_more_less", params) &&
      params.apply_show_more_less == true
    ) {
      self.applyShowMoreLess = true;
    } else {
      self.applyShowMoreLess = false;
    }

    /**
     * Checking what to do when there are
     * no products for the filter
     */
    self.emptyFilters = false;
    if (CP.basicValidation("empty_filters", params)) {
      self.emptyFilters = params.empty_filters;
    }

    /**
     * Update count after every filter
     */
    self.counterUpdate = false;
    self.counterText = "<span>@count items found in @collection.</span>";
    self.counterElement = "";
    if (CP.basicValidation("update_counter", params)) {
      if (!CP.basicValidation("count_element", params.update_counter)) {
        CP.errorHandler(
          "Specify 'count_element' inside 'update_counter' object."
        );
      }
      if ($(document).find(params.update_counter.count_element).length == 0 && params.show_count == true) {
        CP.errorHandler("Cannot find HTML element to update count in DOM.");
      }
      self.counterUpdate = true;
      if (CP.basicValidation("count_text", params.update_counter)) {
        self.counterText = params.update_counter.count_text;
      }
      self.counterElement = params.update_counter.count_element;
    }

    /**
     * Checking clear all element
     */
    self.clearAllElement = false;
    if (CP.basicValidation("clear_all_element", params)) {
      self.clearAllElement = params.clear_all_element;
    }

    if (devMode) {
      console.log(" -- Exiting validateParameters");
    }
  };

  FL.setSubMenuRemovals = function() {
    try {
      if (devMode) {
        console.log(" -- Entering setSubMenuRemovals");
      }
      let self = this;

      self.subMenusToBeRemoved = {};
      if (CP.basicValidation("sub_menus_to_remove", self.params)) {
        for (var m in self.params.sub_menus_to_remove) {
          let trimmedKey = CP.splitAndTrimAndLower(m);
          let trimmedValues = CP.trimAndLowerArray(
            self.params.sub_menus_to_remove[m]
          );
          if (!self.subMenusToBeRemoved.hasOwnProperty(trimmedKey)) {
            let temp = {};
            temp[trimmedKey] = [];
            $.extend(self.subMenusToBeRemoved, temp);
          }
          trimmedValues.forEach(function(x) {
            self.subMenusToBeRemoved[trimmedKey].push(x);
          });
        }
      }

      if (devMode) {
        console.log(" -- Exiting setSubMenuRemovals");
      }
    } catch (ex) {
      errorCatcher(ex, "setSubMenuRemovals");
    }
  };

  FL.getCommonRemovals = function() {
    try {
      if (devMode) {
        console.log(" -- Entering getCommonRemovals");
      }
      this.commonRemovals =
        CP.basicValidation("filter_menu_remove_common", this.params) &&
        this.params.filter_menu_remove_common.length > 0
          ? CP.trimAndLowerArray(this.params.filter_menu_remove_common)
          : [];
      if (devMode) {
        console.log(" -- Exiting getCommonRemovals");
      }
    } catch (ex) {
      errorCatcher(ex, "getCommonRemovals");
    }
  };

  FL.getTagRemovals = function() {
    try {
      if (devMode) {
        console.log(" -- Entering getTagRemovals");
      }
      this.tagsToBeRemoved =
        CP.basicValidation("filter_menu_remove_tags", this.params) &&
        this.params.filter_menu_remove_tags.length > 0
          ? CP.trimAndLowerArray(this.params.filter_menu_remove_tags)
          : [];
      if (devMode) {
        console.log(" -- Exiting getTagRemovals");
      }
    } catch (ex) {
      errorCatcher(ex, "getTagRemovals");
    }
  };

  FL.getOptionRemovals = function() {
    try {
      if (devMode) {
        console.log(" -- Entering getOptionRemovals");
      }
      this.optionsToBeRemoved =
        CP.basicValidation("filter_menu_remove_options", this.params) &&
        this.params.filter_menu_remove_options.length > 0
          ? CP.trimAndLowerArray(this.params.filter_menu_remove_options)
          : [];
      if (devMode) {
        console.log(" -- Exiting getOptionRemovals");
      }
    } catch (ex) {
      errorCatcher(ex, "getOptionRemovals");
    }
  };

  FL.checkTags = function() {
    try {
      if (devMode) {
        console.log(" -- Entering checkTags");
      }
      this.ifTags =
        CP.basicValidation("get_filters_from_tags", this.params) &&
        this.params.get_filters_from_tags == true
          ? true
          : false;
      if (devMode) {
        console.log(" -- Exiting checkTags");
      }
    } catch (ex) {
      errorCatcher(ex, "checkTags");
    }
  };

  FL.checkOptions = function() {
    try {
      if (devMode) {
        console.log(" -- Entering checkOptions");
      }
      this.ifOptions =
        CP.basicValidation("get_filters_from_options", this.params) &&
        this.params.get_filters_from_options == true
          ? true
          : false;
      if (devMode) {
        console.log(" -- Exiting checkOptions");
      }
    } catch (ex) {
      errorCatcher(ex, "checkOptions");
    }
  };

  FL.setRanges = function() {
    try {
      if (devMode) {
        console.log(" -- Entering setRanges");
      }
      let self = this;
      for (let m in self.params.ranges) {
        if (CP.basicChecker(m) && CP.basicChecker(self.params.ranges[m])) {
          let rangeKey = CP.splitAndTrimAndLower(m);
          let curRange = self.params.ranges[m];
          let rangeHeader = curRange.header_name;

          if (!self.ranges.hasOwnProperty(rangeKey)) {
            let temp = {};
            let rangeObj = {};
            rangeObj.header_name = rangeHeader;
            rangeObj.sub_menu = [];
            temp[rangeKey] = rangeObj;
            $.extend(self.ranges, temp);
          }

          if (!self.filterHolder.hasOwnProperty(rangeKey)) {
            let temp = {};
            let headerObj = {};
            headerObj.header_name = rangeHeader;
            headerObj.status = false;
            headerObj.order = 0;
            headerObj.type = "range";
            headerObj.sub_menu = {};
            temp[rangeKey] = headerObj;
            $.extend(self.filterHolder, temp);
          }

          let subMenuOrder = 1;
          if (CP.basicValidation("sub_menu", curRange)) {
            curRange.sub_menu.forEach(function(x) {
              if (CP.basicChecker(x.menu_key) && CP.basicChecker(x.menu_name)) {
                let subMenuKey = CP.splitAndTrimAndLower(x.menu_key);
                let subMenuName = x.menu_name;

                let subMenuObj = {};
                subMenuObj.menu_key = subMenuKey;
                subMenuObj.menu_name = subMenuName;
                self.ranges[rangeKey].sub_menu.push(subMenuObj);

                if (
                  !self.filterHolder[rangeKey].sub_menu.hasOwnProperty(
                    subMenuKey
                  )
                ) {
                  let temp = {};
                  let subMenuObject = {};
                  subMenuObject.menu_name = subMenuName;
                  subMenuObject.status = false;
                  subMenuObject.order = subMenuOrder;
                  temp[subMenuKey] = subMenuObject;
                  $.extend(self.filterHolder[rangeKey].sub_menu, temp);
                  subMenuOrder++;
                }
              }
            });
          }
        }
      }
      if (devMode) {
        console.log(" -- Exiting setRanges");
      }
    } catch (ex) {
      errorCatcher(ex, "setRanges");
    }
  };

  FL.setMenuOrder = function() {
    try {
      if (devMode) {
        console.log(" -- Entering setMenuOrder");
      }
      let self = this;
      let i = 1;
      for (let m in self.params.menu_order) {
        if (CP.basicChecker(m)) {
          let newKey = CP.splitAndTrimAndLower(m);

          if (self.filterHolder.hasOwnProperty(newKey)) {
            self.filterHolder[newKey].order = i;
          } else {
            let temp = {};
            let headerObj = {};
            headerObj.header_name = CP.toTitleCase(
              CP.splitAndTrimAndReverse(m)
            );
            headerObj.status = false;
            headerObj.type = "normal";
            headerObj.order = i;
            headerObj.sub_menu = {};
            temp[newKey] = headerObj;
            $.extend(self.filterHolder, temp);
          }

          if (
            CP.basicChecker(self.params.menu_order[m]) &&
            self.params.menu_order[m].length > 0
          ) {
            let ii = 1;
            for (let n = 0; n < self.params.menu_order[m].length; n++) {
              if (CP.basicChecker(self.params.menu_order[m][n])) {
                let subMenuName = false;
                let subMenuKey = false;
                let subMenuType = _typeof(self.params.menu_order[m][n]);
                if (subMenuType == "object") {
                  let keys = Object.keys(self.params.menu_order[m][n]);
                  if (CP.basicChecker(keys) && CP.basicChecker(keys[0])) {
                    let key = keys[0];
                    if (CP.basicChecker(self.params.menu_order[m][n][key])) {
                      subMenuName = self.params.menu_order[m][n][key];
                      subMenuKey = CP.splitAndTrimAndLower(key);
                    }
                  }
                } else if (subMenuType == "string") {
                  subMenuName = CP.toTitleCase(
                    CP.splitAndTrimAndReverse(self.params.menu_order[m][n])
                  );
                  subMenuKey = CP.splitAndTrimAndLower(
                    self.params.menu_order[m][n]
                  );
                }
                if (subMenuKey && subMenuName) {
                  if (
                    !self.filterHolder[newKey].sub_menu.hasOwnProperty(
                      subMenuKey
                    )
                  ) {
                    let temp = {};
                    let subMenuObj = {};
                    subMenuObj.menu_name = subMenuName;
                    subMenuObj.status = false;
                    subMenuObj.order = ii;
                    temp[subMenuKey] = subMenuObj;
                    $.extend(self.filterHolder[newKey].sub_menu, temp);
                  }
                  ii++;
                }
              }
            }
          }

          i++;
        }
      }
      if (devMode) {
        console.log(" -- Exiting setMenuOrder");
      }
    } catch (ex) {
      errorCatcher(ex, "setMenuOrder");
    }
  };

  FL.initiateFirstLoop = function() {
    try {
      if (devMode) {
        console.log(" -- Entering initiateFirstLoop");
      }
      let self = this;

      let tempProducts = self.allProducts;
      let funcs = [];
      for (let i = 0; i < tempProducts.length; i++) {
        funcs[i] = self.firstLooper(i);
      }
      for (let j = 0; j < tempProducts.length; j++) {
        funcs[j]();
      }
      if (devMode) {
        console.log(" -- Exiting initiateFirstLoop");
      }
    } catch (ex) {
      errorCatcher(ex, "initiateFirstLoop");
    }
  };

  FL.initiateSecondLoop = function() {
    try {
      if (devMode) {
        console.log(" -- Entering initiateSecondLoop");
      }
      let self = this;

      let tempProducts = self.allProducts;
      let funcs = [];
      for (let i = 0; i < tempProducts.length; i++) {
        funcs[i] = self.secondLooper(i);
      }
      for (let j = 0; j < tempProducts.length; j++) {
        funcs[j]();
      }
      if (devMode) {
        console.log(" -- Exiting initiateSecondLoop");
      }
    } catch (ex) {
      errorCatcher(ex, "initiateSecondLoop");
    }
  };

  FL.firstLooper = function(i) {
    try {
      let self = this;

      let params = self.params;
      return function() {
        let prod = self.allProducts[i];

        /**
         * Checking product availability
         */
        let productAvailable =
          (CP.basicValidation("available", prod) && prod.available == true) ||
          (CP.basicValidation("AVL", prod) && prod.AVL == true)
            ? true
            : false;
        if (
          CP.basicValidation("show_unavailable", params) &&
          params.show_unavailable == true
        ) {
          productAvailable = true;
        }

        if (productAvailable) {
          /**
           * Adding a object which holds the
           * search parameters for each element
           */
          prod.searcher = {
            price: []
          };

          /**
           * Setting the price of product
           */
          if (CP.basicValidation("P", prod)) {
            let price = parseFloat(prod.P) / 100;

            /**
             * Check if price is excluded
             */
            if (self.commonRemovals.indexOf("price") == -1) {
              let price_obj = self.createFilterObject(
                "price",
                price,
                "price",
                "Price Range"
              );
              if (price_obj) {
                prod.searcher.price.push(price_obj);
              }
            }
          }

          /**
           * Check if take_vendor is true
           * If true, push to searcher & filter_hold
           */
          if (
            CP.basicChecker(params.take_vendor) &&
            params.take_vendor == true
          ) {
            if (
              CP.basicChecker(params.vendor_show_as) &&
              !self.commonRemovals.hasOwnProperty(params.vendor_show_as)
            ) {
              let vendorKey = params.vendor_show_as;
              let vendorKeyTemp = CP.splitAndTrimAndLower(
                params.vendor_show_as
              );
              if (prod.hasOwnProperty("VE") && CP.basicChecker(prod.VE)) {
                let vendorValue = CP.splitAndTrimAndLower(prod.VE);
                /**
                 * Pushing to filter_hold & searcher
                 */
                if (self.commonRemovals.indexOf(vendorKeyTemp) == -1) {
                  if (!prod.searcher.hasOwnProperty(vendorKeyTemp)) {
                    let temp = {};
                    temp[vendorKeyTemp] = [];
                    $.extend(prod.searcher, temp);
                  }
                  let vendor_obj = self.createFilterObject(
                    vendorKeyTemp,
                    vendorValue,
                    "vendor",
                    vendorKey,
                    prod.VE.toString()
                  );
                  if (vendor_obj) {
                    prod.searcher[vendorKeyTemp].push(vendor_obj);
                  }
                }
              }
            }
          }

          /**
           * Check if take_product_type is true
           * If true, push to searcher & filter_hold
           */
          if (
            CP.basicChecker(params.take_product_type) &&
            params.take_product_type == true
          ) {
            if (
              CP.basicChecker(params.product_type_show_as) &&
              !self.commonRemovals.hasOwnProperty(params.product_type_show_as)
            ) {
              let productTypeKey = params.product_type_show_as;
              let productTypeKeyTemp = CP.splitAndTrimAndLower(
                params.product_type_show_as
              );
              if (prod.hasOwnProperty("PT")) {
                let productTypeValue = CP.splitAndTrimAndLower(prod.PT);

                /**
                 * Pushing to filter_hold & searcher
                 */
                if (self.commonRemovals.indexOf(productTypeKeyTemp) == -1) {
                  if (!prod.searcher.hasOwnProperty(productTypeKeyTemp)) {
                    let temp = {};
                    temp[productTypeKeyTemp] = [];
                    $.extend(prod.searcher, temp);
                  }
                  let product_type_obj = self.createFilterObject(
                    productTypeKeyTemp,
                    productTypeValue,
                    "product_type",
                    productTypeKey,
                    prod.PT.toString()
                  );
                  if (product_type_obj) {
                    prod.searcher[productTypeKeyTemp].push(product_type_obj);
                  }
                }
              }
            }
          }

          /**
           * Get Tags
           */
          let tempTags = {};
          if (self.ifTags) {
            tempTags = self.getProductTags(i);
          }
          if (!jQuery.isEmptyObject(tempTags)) {
            for (let t in tempTags) {
              if (CP.basicChecker(t) && CP.basicChecker(tempTags[t])) {
                /**
                 * Pushing to searcher object
                 */
                if (!prod.searcher.hasOwnProperty(t)) {
                  let temp = {};
                  temp[t] = [];
                  $.extend(prod.searcher, temp);
                }
                for (let q = 0; q < tempTags[t].length; q++) {
                  if (CP.basicChecker(tempTags[t][q])) {
                    let cur = tempTags[t][q];
                    if (prod.searcher[t].indexOf(cur.toString().trim()) == -1) {
                      prod.searcher[t].push(cur.toString().trim());
                    }
                  }
                }
              }
            }
          }

          /**
           * Get Options
           */
          let tempOptions = {};
          if (self.ifOptions) {
            tempOptions = self.getProductOptions(i);
          }
          if (!jQuery.isEmptyObject(tempOptions)) {
            for (let t in tempOptions) {
              if (CP.basicChecker(t) && CP.basicChecker(tempOptions[t])) {
                /**
                 * Pushing to searcher object
                 */
                if (!prod.searcher.hasOwnProperty(t)) {
                  let temp = {};
                  temp[t] = [];
                  $.extend(prod.searcher, temp);
                }
                for (let q = 0; q < tempOptions[t].length; q++) {
                  if (CP.basicChecker(tempOptions[t][q])) {
                    let cur = tempOptions[t][q];
                    if (prod.searcher[t].indexOf(cur) == -1) {
                      prod.searcher[t].push(cur);
                    }
                  }
                }
              }
            }
          }

          self.allProducts[i] = prod;
        }
      };
    } catch (ex) {
      errorCatcher(ex, "firstLooper");
    }
  };

  FL.secondLooper = function(i) {
    try {
      let self = this;

      return function() {
        let prod = self.allProducts[i];

        let tagKeys = Object.keys(prod.searcher);
        let tagKeys2 = Object.keys(self.filterHolder);
        let diffs = CP.compareArrays(tagKeys2, tagKeys);

        if (diffs.length > 0) {
          for (let j = diffs.length - 1; j >= 0; j--) {
            if (CP.basicChecker(diffs[j])) {
              if (!prod.searcher.hasOwnProperty(diffs[j])) {
                let temp = {};
                temp[diffs[j]] = [];
                $.extend(prod.searcher, temp);
              }
            }
          }
        }

        self.allProducts[i] = prod;
      };
    } catch (ex) {
      errorCatcher(ex, "secondLooper");
    }
  };

  FL.createFilterObject = function(key, val) {
    try {
      let self = this;

      let type =
        arguments.length > 2 && CP.basicChecker(arguments[2])
          ? arguments[2]
          : "";
      let headerName =
        arguments.length > 3 && CP.basicChecker(arguments[3])
          ? arguments[3]
          : CP.toTitleCase(CP.splitAndTrimAndReverse(key));
      let menuName =
        arguments.length > 4 && CP.basicChecker(arguments[4])
          ? arguments[4]
          : CP.toTitleCase(CP.splitAndTrimAndReverse(val));

      let filterObj = false;
      let addStatus = true;

      if (self.commonRemovals.indexOf(key) !== -1) {
        addStatus = false;
      }
      if (type == "tag" && self.tagsToBeRemoved.indexOf(key) !== -1) {
        addStatus = false;
      }
      if (type == "option" && self.optionsToBeRemoved.indexOf(key) !== -1) {
        addStatus = false;
      }

      if (addStatus == true) {
        if (!self.filterHolder.hasOwnProperty(key)) {
          let temp = {};
          let headerObj = {};
          headerObj.header_name = headerName;
          headerObj.status = false;
          headerObj.type = "normal";
          headerObj.order = 0;
          headerObj.sub_menu = {};
          temp[key] = headerObj;
          $.extend(self.filterHolder, temp);
        }
        if (self.filterHolder[key].type == "range") {
          filterObj = self.getRange(key, val);
        } else {
          filterObj = val;
        }
        if (filterObj) {
          if (!self.filterHolder[key].sub_menu.hasOwnProperty(filterObj)) {
            let temp = {};
            let subMenuObj = {};
            subMenuObj.menu_name = menuName;
            subMenuObj.status = true;
            subMenuObj.order = 0;
            temp[filterObj] = subMenuObj;
            $.extend(self.filterHolder[key].sub_menu, temp);
          } else {
            self.filterHolder[key].sub_menu[filterObj].status = true;
          }
        }
      }
      return filterObj;
    } catch (ex) {
      errorCatcher(ex, "createFilterObject");
    }
  };

  FL.getRange = function(key, val) {
    try {
      let self = this;

      let retVal = false;
      if (CP.basicValidation(key, self.ranges)) {
        let rangeObj = self.ranges[key];
        val = parseFloat(val);
        rangeObj.sub_menu.forEach(function(x) {
          let subKey = x.menu_key;
          let subKeys = subKey.split("-");
          if (subKeys[0] == "@min_range") {
            if (val <= parseFloat(subKeys[1])) {
              retVal = subKey;
            }
          } else if (subKeys[1] == "@max_range") {
            if (val >= parseFloat(subKeys[0])) {
              retVal = subKey;
            }
          } else {
            if (
              val >= parseFloat(subKeys[0]) &&
              val <= parseFloat(subKeys[1])
            ) {
              retVal = subKey;
            }
          }
        });
      }
      return retVal;
    } catch (ex) {
      errorCatcher(ex, "getRange");
    }
  };

  FL.getProductTags = function(i) {
    try {
      let self = this;

      let prod = self.allProducts[i];
      let currentTags = {};
      if (CP.basicValidation("TG", prod)) {
        for (let j = 0; j < prod.TG.length; j++) {
          let productTag = prod.TG[j];
          if (productTag.indexOf(":") !== -1) {
            let productTags = productTag.split(":");
            if (
              CP.basicChecker(productTags[0]) &&
              CP.basicChecker(productTags[1])
            ) {
              let actualTagHeader = productTags[0];
              let actualTagValue = productTags[1];
              let tagHeader = CP.splitAndTrimAndLower(productTags[0]);
              let tagValue = CP.splitAndTrimAndLower(productTags[1]);

              if (self.hasRanges && self.ranges.hasOwnProperty(tagHeader)) {
                tagValue = parseFloat(tagValue.match(/[\d\.]+/));
              }
              let addStatus = true;

              if (self.commonRemovals.length > 0) {
                if (self.commonRemovals.indexOf(tagHeader) !== -1) {
                  addStatus = false;
                }
              }
              if (self.tagsToBeRemoved.length > 0) {
                if (self.tagsToBeRemoved.indexOf(tagHeader) !== -1) {
                  addStatus = false;
                }
              }
              if (
                self.subMenusToBeRemoved.hasOwnProperty(tagHeader) &&
                self.subMenusToBeRemoved[tagHeader].indexOf(tagValue) !== -1
              ) {
                addStatus = false;
              }
              if (addStatus) {
                let tagObj = self.createFilterObject(
                  tagHeader,
                  tagValue,
                  "tag",
                  actualTagHeader,
                  actualTagValue
                );
                if (tagObj) {
                  if (!currentTags.hasOwnProperty(tagHeader)) {
                    let temp = {};
                    temp[tagHeader] = [];
                    $.extend(currentTags, temp);
                  }
                  if (currentTags[tagHeader].indexOf(tagObj) == -1) {
                    currentTags[tagHeader].push(tagObj);
                  }
                }
              }
            }
          }
        }
      }
      return currentTags;
    } catch (ex) {
      errorCatcher(ex, "getProductTags");
    }
  };

  FL.getProductOptions = function(i) {
    try {
      let self = this;

      let currentOptions = {};
      let prod = self.allProducts[i];

      if (CP.basicValidation("O", prod) && CP.basicValidation("VA", prod)) {
        let productOptions = prod.O;
        let productVariants = prod.VA;

        for (let j = productVariants.length - 1; j >= 0; j--) {
          productOptions.forEach(function(item_, indx_) {
            if (CP.basicChecker(item_) && item_ != "Title") {
              let actualKey = item_;
              let key = CP.splitAndTrimAndLowerOptions(item_);
              let tempKey = CP.splitAndTrimAndLower(item_);
              let addStatus = true;

              if (self.commonRemovals.length > 0) {
                if (
                  self.commonRemovals.indexOf(tempKey) !== -1 ||
                  self.commonRemovals.indexOf(key) !== -1
                ) {
                  addStatus = false;
                }
              }
              if (self.optionsToBeRemoved.length > 0) {
                if (
                  self.optionsToBeRemoved.indexOf(tempKey) !== -1 ||
                  self.optionsToBeRemoved.indexOf(key) !== -1
                ) {
                  addStatus = false;
                }
              }

              if (addStatus) {
                let optionNumber = false;
                if (indx_ == 0) {
                  optionNumber = "O1";
                } else if (indx_ == 1) {
                  optionNumber = "O2";
                } else {
                  optionNumber = "O3";
                }

                if (optionNumber) {
                  if (CP.basicValidation(optionNumber, productVariants[j])) {
                    let actualValue = productVariants[j][optionNumber];
                    let value = CP.splitAndTrimAndLower(
                      productVariants[j][optionNumber]
                    );
                    addStatus = true;
                    if (
                      self.subMenusToBeRemoved.hasOwnProperty(tempKey) &&
                      self.subMenusToBeRemoved[tempKey].indexOf(value) !== -1
                    ) {
                      addStatus = false;
                    }
                    if (
                      self.subMenusToBeRemoved.hasOwnProperty(key) &&
                      self.subMenusToBeRemoved[key].indexOf(value) !== -1
                    ) {
                      addStatus = false;
                    }

                    if (addStatus) {
                      if (self.hasRanges && self.ranges.hasOwnProperty(key)) {
                        value = parseFloat(value.match(/[\d\.]+/));
                      }

                      let opt_obj = self.createFilterObject(
                        key,
                        value,
                        "option",
                        actualKey,
                        actualValue
                      );
                      if (opt_obj) {
                        if (!currentOptions.hasOwnProperty(key)) {
                          let temp = {};
                          temp[key] = [];
                          $.extend(currentOptions, temp);
                        }
                        if (currentOptions[key].indexOf(opt_obj) == -1) {
                          currentOptions[key].push(opt_obj);
                        }
                      }
                    }
                  }
                }
              }
            }
          });
        }
      }
      return currentOptions;
    } catch (ex) {
      errorCatcher(ex, "getProductOptions");
    }
  };

  FL.reorderMenu = function() {
    try {
      if (devMode) {
        console.log(" -- Entering reorderMenu");
      }
      let self = this;

      let holder = self.filterHolder;
      let unOrderedHeaders = [];
      let orderedHeaders = [];

      let sortedFilter = Object.keys(holder).sort(function(keyA, keyB) {
        return holder[keyA].order - holder[keyB].order;
      });
      sortedFilter.forEach(function(element) {
        if (holder[element].order == 0) {
          unOrderedHeaders.push(element);
        } else {
          orderedHeaders.push(element);
        }
      });
      unOrderedHeaders = CP.naturalSorter(unOrderedHeaders);
      let actualOrder = orderedHeaders.concat(unOrderedHeaders);
      let finalOrder = [];
      actualOrder.forEach(function(ele) {
        let obj = {};
        obj.header_name = self.getCustomHeaders(
          self.filterHolder[ele].header_name
        );
        obj.order = self.filterHolder[ele].order;
        obj.status = self.filterHolder[ele].status;
        obj.type = self.filterHolder[ele].type;
        obj.header_key = ele;
        obj.sub_menu = [];

        let subs = self.filterHolder[ele].sub_menu;
        let unOrderedSubs = [];
        let orderedSubs = [];
        let sortedSubs = Object.keys(subs).sort(function(keyA, keyB) {
          return subs[keyA].order - subs[keyB].order;
        });
        sortedSubs.forEach(function(element) {
          if (subs[element].order == 0) {
            unOrderedSubs.push(element);
          } else {
            orderedSubs.push(element);
          }
        });
        unOrderedSubs = CP.naturalSorter(unOrderedSubs);
        let subOrder = orderedSubs.concat(unOrderedSubs);
        subOrder.forEach(function(ele_) {
          let subMenuObject = {};
          subMenuObject.menu_name =
            self.filterHolder[ele].sub_menu[ele_].menu_name;
          subMenuObject.menu_key = ele_;
          subMenuObject.order = self.filterHolder[ele].sub_menu[ele_].order;
          subMenuObject.status = self.filterHolder[ele].sub_menu[ele_].status;
          obj.sub_menu.push(subMenuObject);
        });
        finalOrder.push(obj);
      });
      if (devMode) {
        console.log(" -- Exiting reorderMenu");
      }
      return finalOrder;
    } catch (ex) {
      errorCatcher(ex, "reorderMenu");
    }
  };

  FL.getCustomHeaders = function(currentHeader) {
    try {
      let self = this;

      let retVal = currentHeader;
      let trimmedHeader = CP.splitAndTrimAndLower(currentHeader);
      if (self.customHeaders) {
        if (self.customHeaders.hasOwnProperty(currentHeader)) {
          if (CP.basicChecker(self.customHeaders[currentHeader])) {
            retVal = self.customHeaders[currentHeader];
          }
        } else if (self.customHeaders.hasOwnProperty(trimmedHeader)) {
          if (CP.basicChecker(self.customHeaders[trimmedHeader])) {
            retVal = self.customHeaders[trimmedHeader];
          }
        }
      }
      return retVal;
    } catch (ex) {
      errorCatcher(ex, "getCustomHeaders");
    }
  };

  FL.buildSideBar = function() {
    try {
      if (devMode) {
        performance.mark("sidebar-start");
        console.log(
          " -- Entering buildSideBar at " +
            performance.getEntriesByName("sidebar-start")[0].startTime
        );
      }

      let self = this;

      let tempHtml = "";
      let headerCount = 0;
      let menuCount = 0;

      self.finalOrder.forEach(function(head, x) {
        if (CP.basicChecker(head)) {
          let headerKey = head.header_key;
          let headerName = head.header_name;
          let encodedHeaderKey = encodeURIComponent(
            headerKey.split("_").join("-")
          );

          headerCount++;
          let menuCountUnderHeader = 0;

          let startingHtml =
            self.customSideBarHtml &&
            self.customSideBarHtml.hasOwnProperty(headerKey) &&
            CP.basicValidation(
              "starting_html_element",
              self.customSideBarHtml[headerKey]
            )
              ? self.customSideBarHtml[headerKey].starting_html_element
              : self.starting_html_element;
          let endingHtml =
            self.customSideBarHtml &&
            self.customSideBarHtml.hasOwnProperty(headerKey) &&
            CP.basicValidation(
              "ending_html_element",
              self.customSideBarHtml[headerKey]
            )
              ? self.customSideBarHtml[headerKey].ending_html_element
              : self.ending_html_element;
          let parentStartingHtml =
            self.customSideBarHtml &&
            self.customSideBarHtml.hasOwnProperty(headerKey) &&
            CP.basicValidation(
              "parent_starting_html_element",
              self.customSideBarHtml[headerKey]
            )
              ? self.customSideBarHtml[headerKey].parent_starting_html_element
              : self.parent_starting_html_element;
          let parentEndingHtml =
            self.customSideBarHtml &&
            self.customSideBarHtml.hasOwnProperty(headerKey) &&
            CP.basicValidation(
              "parent_ending_html_element",
              self.customSideBarHtml[headerKey]
            )
              ? self.customSideBarHtml[headerKey].parent_ending_html_element
              : self.parent_ending_html_element;

          let s = CP.stringReplace(startingHtml, "@header_key", headerKey);
          s = CP.stringReplace(s, "@header_name", headerName);
          s = CP.stringReplace(s, "@header_count", parseInt(headerCount));
          s = CP.stringReplace(
            s,
            "@menu_count_under_header",
            parseInt(menuCountUnderHeader)
          );
          s = CP.stringReplace(s, "@menu_count", parseInt(menuCount));

          let ps = CP.stringReplace(
            parentStartingHtml,
            "@header_name",
            headerName
          );
          ps = CP.stringReplace(ps, "@p_class", filtzParentClass);
          ps = CP.stringReplace(ps, "@menu_count", parseInt(menuCount));
          ps = CP.stringReplace(ps, "@header_name", headerName);
          ps = CP.stringReplace(ps, "@header_key", headerKey);
          ps = CP.stringReplace(
            ps,
            "@menu_count_under_header",
            parseInt(menuCountUnderHeader)
          );
          ps = CP.stringReplace(ps, "@menu_count", parseInt(menuCount));
          ps = CP.stringReplace(ps, "@header_count", parseInt(headerCount));

          let pe = CP.stringReplace(
            parentEndingHtml,
            "@header_name",
            headerName
          );
          pe = CP.stringReplace(pe, "@menu_count", parseInt(menuCount));
          pe = CP.stringReplace(pe, "@header_key", headerKey);
          pe = CP.stringReplace(
            pe,
            "@menu_count_under_header",
            parseInt(menuCountUnderHeader)
          );
          pe = CP.stringReplace(pe, "@menu_count", parseInt(menuCount));
          pe = CP.stringReplace(pe, "@header_count", parseInt(headerCount));

          let e = CP.stringReplace(endingHtml, "@header_key", headerKey);
          e = CP.stringReplace(e, "@menu_count", parseInt(menuCount));
          e = CP.stringReplace(e, "@header_key", headerKey);
          e = CP.stringReplace(
            e,
            "@menu_count_under_header",
            parseInt(menuCountUnderHeader)
          );
          e = CP.stringReplace(e, "@menu_count", parseInt(menuCount));
          e = CP.stringReplace(e, "@header_count", parseInt(headerCount));

          let subs = [];
          head.sub_menu.forEach(function(sub, y) {
            if (CP.basicChecker(sub)) {
              let menuName = sub.menu_name;
              let menuKey = sub.menu_key;
              let menuStatus = sub.status;
              if (menuStatus) {
                let tempMenuKey = CP.stringReplace(
                  menuKey,
                  "@max_range",
                  "above"
                );
                tempMenuKey = CP.stringReplace(
                  tempMenuKey,
                  "@min_range",
                  "below"
                );
                let encodedMenuKey = encodeURIComponent(
                  tempMenuKey.split("_").join("-")
                );

                menuCount++;
                menuCountUnderHeader++;

                let sub_html =
                  self.customSideBarHtml.hasOwnProperty(headerKey) &&
                  CP.basicValidation(
                    "sub_menu_html_element",
                    self.customSideBarHtml[headerKey]
                  )
                    ? self.customSideBarHtml[headerKey].sub_menu_html_element
                    : self.sub_menu_html_element;
                let sb = CP.stringReplace(sub_html, "@header_key", headerKey);
                sb = CP.stringReplace(sb, "@header_name", headerName);
                sb = CP.stringReplace(sb, "@menu_key", menuKey);
                sb = CP.stringReplace(sb, "@menu_name", menuName);
                sb = CP.stringReplace(
                  sb,
                  "@header_count",
                  parseInt(headerCount)
                );
                sb = CP.stringReplace(
                  sb,
                  "@menu_count_under_header",
                  parseInt(menuCountUnderHeader)
                );
                sb = CP.stringReplace(sb, "@menu_count", parseInt(menuCount));
                sb = CP.stringReplace(sb, "@c_class", filtzChildClass);

                /**
                 * Setting count element
                 */
                if (self.showCount) {
                  sb = CP.stringReplace(
                    sb,
                    "@count_placing",
                    self.countElement
                  );
                  sb = CP.stringReplace(
                    sb,
                    "@count_class",
                    self.defaultFilterCountClass
                  );
                } else {
                  sb = CP.stringReplace(sb, "@count_placing", "");
                }

                let tempSub = $(sb);
                if (!tempSub.hasClass(self.childClass)) {
                  tempSub.addClass(self.childClass);
                }
                tempSub.attr("filter", menuKey);
                tempSub.attr("encodedfilter", encodedMenuKey);
                tempSub.attr("filtzstate", 0);
                tempSub.attr("filtername", menuName);
                sb = CP.htmlToString(tempSub);

                subs.push(sb);
              }
            }
          });

          let filterCatchClass = "filtz_crit_" + CP.escaper(headerKey);
          let typeInfo = "usuall";

          let firstCoverElement = $(ps + subs.join("") + pe);
          if (!firstCoverElement.hasClass(filterCatchClass)) {
            firstCoverElement.addClass(filterCatchClass);
          }
          if (!firstCoverElement.hasClass(self.parentClass)) {
            first_cover_ele.addClass(self.childClass);
          }
          firstCoverElement.attr("filterType", typeInfo);
          firstCoverElement.attr("filterKey", headerKey);
          firstCoverElement.attr("encodedfilterKey", encodedHeaderKey);
          firstCoverElement.attr("filtername", headerName);
          let firstCoverElementString = CP.htmlToString(firstCoverElement);

          let secondCoverElement = $(s + firstCoverElementString + e);

          let tempDom = CP.htmlToString(secondCoverElement);
          tempHtml += tempDom;
        }
      });

      if (self.preLoader) {
        $(document)
          .find(self.preLoader)
          .remove();
      }
      $(self.sideBarElement)
        .empty()
        .append(tempHtml);

      if (self.applyShowMoreLess) {
        applyShowMoreLess();
      }

      if ($(document).find("#" + self.initialProductsContainer).length == 0) {
        $("body").append(
          '<div class="hide" id="' +
            self.initialProductsContainer +
            '" style="display:none !important;"></div>'
        );
      }

      if (devMode) {
        performance.mark("sidebar-stop");
        console.log(
          " -- Exiting buildSideBar at " +
            performance.getEntriesByName("sidebar-stop")[0].startTime
        );
      }
    } catch (ex) {
      errorCatcher(ex, "buildSideBar");
    }
  };

  var FILTz = function(params) {
    this.params = params;
    let FLTz = new InitiateFILTz(this.params);

    $.when(FLTz).done(function() {
      let cred = {
        allProducts: FLTz.allProducts,
        defaultContainer: FLTz.initialProductsContainer,
        actualContainer: FLTz.productsContainer,
        filterAppliedCount: FLTz.filterAppliedCount,
        productsProcessor: FLTz.productsProcessor,
        filtzPaginationElement: FLTz.filtzPaginationElement,
        liquidPaginationElement: FLTz.liquidPaginationElement,
        sideBarElement: FLTz.sideBarElement,
        permanentToggleClass: FLTz.permanentToggleClass,
        toggleClass: FLTz.toggleClass,
        showPerPage: FLTz.showPerPage,
        perPageValues: FLTz.perPageValues,
        perPageElement: FLTz.perPageElement,
        showSort: FLTz.showSort,
        sortElement: FLTz.sortElement,
        emptyElement: FLTz.emptyElement,
        activeFilter: FLTz.activeFilter,
        activeFilterObj: FLTz.activeFilterObj,
        showCount: FLTz.showCount,
        defaultFilterCountClass: FLTz.defaultFilterCountClass,
        applyShowMoreLess: FLTz.applyShowMoreLess,
        emptyFilters: FLTz.emptyFilters,
        counterUpdate: FLTz.counterUpdate,
        counterText: FLTz.counterText,
        counterElement: FLTz.counterElement,
        clearAllElement: FLTz.clearAllElement
      };

      let FHL = new FILTzHandler(cred);
      window.FHL = FHL;

      let createFILTzObj = FHL.createFILTzObj(FLTz.allProducts);

      $.when(createFILTzObj).done(function() {
        let binders = FHL.bindCommonEvents();
        $.when(binders).done(function() {
          let applyFromURL = FHL.applyFILTzFromURL();
          $.when(applyFromURL).done(function() {
            let finisherFunctions = FHL.wrapUpFunctions();
            $.when(finisherFunctions).done(function() {
              if (devMode) {
                performance.mark("process-stop");
                console.log(
                  " -- Process finished at " +
                    performance.getEntriesByName("process-stop")[0].startTime
                );
                console.log(
                  "========================================================================="
                );
              }
            });
          });
        });
      });
    });
  };
  window.FILTz = FILTz;

  function FILTzHandler(cred) {
    for (let m in cred) {
      if (CP.basicChecker(m)) {
        if (!this.hasOwnProperty(m)) {
          let temp = {};
          temp[m] = "";
          $.extend(this, temp);
        }
        this[m] = cred[m];
      }
    }

    this.isPopStateEvent = false;

    this.currentSort = false;
    if (this.showSort) {
      this.currentSort = defaultOrder;
    }

    this.currentPerPage = false;
    if (this.showPerPage) {
      this.currentPerPage = $(document)
        .find(this.perPageElement)
        .val();
      this.actualPerPageElement = ".filtz__per-page-selecter";
    }
    if (devMode) {
      console.log(" -- Current FILTZ handler is ", this);
    }
  }

  let FH = FILTzHandler.prototype;

  FH.createFILTzObj = function() {
    try {
      let self = this;

      let products =
        arguments.length > 0 && CP.basicChecker(arguments[0])
          ? arguments[0]
          : self.allProducts;

      let productLoader =
        self.filterAppliedCount > 0
          ? self.actualContainer
          : self.defaultContainer;
      let filtz_obj = {
        template: self.productsProcessor,
        callbacks: {
          beforeAddRecords: beforeAddRecords,
          afterAddRecords: afterAddRecords,
          beforeRender: beforeRender,
          beforeRecordRender: beforeRecordRender,
          afterFilter: afterFilter
        }
      };

      let page_obj = {};
      page_obj.container = self.filtzPaginationElement;
      page_obj.visiblePages = 5;
      let per_page_obj = {};
      per_page_obj.values = self.perPageValues;
      per_page_obj.container = self.perPageElement;
      page_obj.perPage = per_page_obj;
      filtz_obj.pagination = page_obj;

      let criterias = self.getCriteriasFromSideBar();
      filtz_obj.criterias = criterias;

      let checkAndApply = function() {
        if (typeof FilterJS !== "undefined" && typeof FilterJS == "function") {
          FJS = FilterJS(products, productLoader, filtz_obj);
          window.FJS = FJS;
        } else {
          setTimeout(function() {
            checkAndApply();
          }, 0);
        }
      };

      checkAndApply();
    } catch (ex) {
      errorCatcher(ex, "createFILTzObj");
    }
  };

  FH.getCriteriasFromSideBar = function() {
    try {
      let self = this;

      let criterias = [];
      $(self.sideBarElement)
        .find("." + filtzParentClass)
        .each(function() {
          let filter_type = $(this).attr("filtertype");
          let filter_key = $(this).attr("filterkey");
          if (CP.basicChecker(filter_type) && CP.basicChecker(filter_key)) {
            let selector_ = "";
            if ($(this).is("div")) {
              selector_ = "div";
            } else if ($(this).is("li")) {
              selector_ = "li";
            } else if ($(this).is("ul")) {
              selector_ = "ul";
            }

            let criteria_obj = {
              field: "searcher." + filter_key,
              ele: ".filtz_crit_" + CP.escaper(filter_key),
              event: "click",
              selector: selector_
            };

            if (filter_type == "range") {
              criteria_obj.type = "range";
            }

            criterias.push(criteria_obj);
          }
        });
      return criterias;
    } catch (ex) {
      errorCatcher(ex, "getCriteriasFromSideBar");
    }
  };

  FH.addCriteriaFromSideBar = function() {
    try {
      let self = this;

      let criterias = self.getCriteriasFromSideBar();
      criterias.forEach(function(ele) {
        FJS.addCriteria(ele);
      });
    } catch (ex) {
      errorCatcher(ex, "addCriteriaFromSideBar");
    }
  };

  FH.checkProductLoadingElement = function() {
    try {
      if (devMode) {
        console.log(" -- Entering checkProductLoadingElement");
      }
      let self = this;

      if (self.filterAppliedCount > 0 && FJS.hasOwnProperty("$container")) {
        if (!$(self.actualContainer).hasClass("filtz__product-container")) {
          $(self.actualContainer).addClass("filtz__product-container");
          $(self.defaultContainer)
            .empty()
            .hide();
          FJS.$container = $(self.actualContainer).show();
          if (devMode) {
            console.log(
              " -- >> Loading template changed at checkProductLoadingElement()"
            );
          }
        }
      }
      if (devMode) {
        console.log(" -- Exiting checkProductLoadingElement");
      }
    } catch (ex) {
      errorCatcher(ex, "checkProductLoadingElement");
    }
  };

  FH.preFilter = function() {
    try {
      if (devMode) {
        console.log(" -- Entering preFilter");
      }
      let self = this;

      self.filtzTriggered();
      self.checkProductLoadingElement();
      if (devMode) {
        console.log(" -- Exiting preFilter");
      }
    } catch (ex) {
      errorCatcher(ex, "preFilter");
    }
  };

  FH.sidebarClicked = function(ele) {
    try {
      if (devMode) {
        console.log(" -- Entering sidebarClicked");
      }
      let self = this;

      let clickedEle = $(ele);
      let stateAttribute = clickedEle.attr("filtzstate");
      if (typeof stateAttribute === "undefined" || stateAttribute === false) {
        clickedEle = clickedEle.closest("." + filtzChildClass);
        stateAttribute = clickedEle.attr("filtzstate");
      }
      if (stateAttribute == 0) {
        clickedEle.addClass(self.permanentToggleClass);
        clickedEle.attr("filtzstate", 1);
      } else {
        clickedEle.attr("filtzstate", 0);
        clickedEle.removeClass(self.permanentToggleClass);
      }
      if (self.toggleClass) {
        clickedEle.toggleClass(self.toggleClass);
      }
      self.setURL("filter");
      filterClicked(
        clickedEle.closest("." + filtzParentClass).attr("filterkey"),
        clickedEle.attr("filter"),
        clickedEle
      );
      if (devMode) {
        console.log(" -- Exiting sidebarClicked");
      }
    } catch (ex) {
      errorCatcher(ex, "sidebarClicked");
    }
  };

  FH.pageTriggered = function(page) {
    try {
      if (devMode) {
        console.log(" -- Entering pageTriggered");
        console.log(" -- >> Page num " + page + " clicked");
      }
      let self = this;

      self.setURL("page");
      pageChanged(page);
      if (devMode) {
        console.log(" -- Exiting pageTriggered");
      }
    } catch (ex) {
      errorCatcher(ex, "pageTriggered");
    }
  };

  FH.perPageTriggered = function(value) {
    try {
      if (devMode) {
        console.log(" -- Entering perPageTriggered");
        console.log(" -- >> Per Page num " + value + " clicked");
      }
      let self = this;

      self.setURL("per_page");
      perPageChanged(value);
      if (devMode) {
        console.log(" -- Exiting perPageTriggered");
      }
    } catch (ex) {
      errorCatcher(ex, "perPageTriggered");
    }
  };

  FH.filtzTriggered = function() {
    try {
      if (devMode) {
        console.log(" -- Entering filtzTriggered");
      }
      this.filterAppliedCount++;
      this.checkModel();
      this.showFILTzPagination();
      $("html, body").animate({ scrollTop: 0 }, "fast");
      if (devMode) {
        console.log(" -- Exiting filtzTriggered");
      }
    } catch (ex) {
      errorCatcher(ex, "filtzTriggered");
    }
  };

  FH.afterFilter = function(records, jQ) {
    try {
      if (devMode) {
        console.log(" -- Entering afterFilter");
        console.log(
          " -- >> " + records.length + " records in the afterFilter callback"
        );
      }
      let self = this;

      if (self.counterUpdate == true && self.filterAppliedCount > 0) {
        let countText = self.counterText;
        countText = CP.stringReplace(countText, "@count", records.length);
        if (countText.indexOf("@collection") !== -1) {
          let collectionName = "Collection";
          let current_url = window.location.href;
          if (current_url.indexOf("/search") !== -1) {
            collectionName = "Search";
          } else {
            collectionName = CP.toTitleCase(
              collectionName.split("-").join(" ")
            );
          }
          countText = CP.stringReplace(
            countText,
            "@collection",
            collectionName
          );
        }
        $(document)
          .find(self.counterElement)
          .empty()
          .append(countText);
      }

      if (self.activeFilter == true) {
        $(document)
          .find(self.activeFilterObj.container)
          .hide();
      }

      if (
        records.length == 0 &&
        self.filterAppliedCount > 0 &&
        CP.basicChecker(self.emptyElement)
      ) {
        $(document)
          .find(self.productsContainer)
          .hide();
        $(self.emptyElement).show();
      } else {
        $(document)
          .find(self.productsContainer)
          .show();
        $(self.emptyElement).hide();
      }

      let selected_filters = {};
      $(self.sideBarElement)
        .find("." + filtzParentClass)
        .each(function(e) {
          let parent = $(this);
          parent.show();
          let parent_key = parent.attr("filterkey");
          let parent_key_encoded = parent.attr("encodedfilterkey");
          let parent_name = parent.attr("filtername");
          let count_under_parent = 0;

          parent.find("." + filtzChildClass).each(function(ev) {
            let child = $(this);
            child.show();
            let child_key = child.attr("filter");
            let child_key_encoded = child.attr("encodedfilter");
            let child_name = child.attr("filtername");
            let state = child.attr("filtzstate");
            let count_of_child = 0;

            if (
              CP.basicChecker(state) &&
              state == 1 &&
              CP.basicChecker(parent_key) &&
              CP.basicChecker(child_key)
            ) {
              if (!selected_filters.hasOwnProperty(parent_key_encoded)) {
                let temp = {};
                temp[parent_key_encoded] = {
                  header_name: parent_name,
                  sub_menus: {}
                };
                $.extend(selected_filters, temp);
              }
              if (
                !selected_filters[parent_key_encoded].sub_menus.hasOwnProperty(
                  child_key_encoded
                )
              ) {
                let temp = {};
                temp[child_key_encoded] = child_name;
                $.extend(selected_filters[parent_key_encoded].sub_menus, temp);
              }
            }

            if (records.length > 0) {
              let searcher = {};
              let tmp = {};
              tmp["searcher." + parent_key] = child_key;
              $.extend(searcher, tmp);
              count_of_child = jQ.where(searcher).count;
              count_under_parent += count_of_child;
            }

            if (self.showCount == true) {
              let count_text = "";
              if (count_of_child > 0) {
                count_text = " (" + count_of_child + ")";
              }
              child.find("." + self.defaultFilterCountClass).text(count_text);
            }

            if (CP.basicChecker(self.emptyFilters)) {
              if (count_of_child == 0) {
                if (
                  self.emptyFilters == "hide_sub_menu_only" ||
                  self.emptyFilters == "hide_main_menu"
                ) {
                  child.hide();
                }
              }
            }
          });

          if (self.emptyFilters) {
            if (count_under_parent == 0) {
              if (self.emptyFilters == "hide_main_menu") {
                parent.hide();
              }
            }
          }

          if (parent.find("." + filtzChildClass).length == 0) {
            parent.hide();
          }
        });

      if (self.activeFilter) {
        self.renderActiveFilter(selected_filters);
      }

      if (devMode) {
        console.log(" -- Exiting afterFilter");
      }
    } catch (ex) {
      errorCatcher(ex, "afterFilter");
    }
  };

  FH.setURL = function(source) {
    try {
      if (devMode) {
        console.log(" -- Entering setURL");
      }
      let self = this;

      if (!self.isPopStateEvent) {
        let currentFilters = self.getSideBarFilters();
        let urlParameters = self.getUrlParameters();
        if (!urlParameters.hasOwnProperty("page")) {
          let temp = {};
          temp["page"] = [1];
          $.extend(urlParameters, temp);
        }

        let filtzPageNum = FJS.page.currentPage;
        let urlPageNum =
          urlParameters.hasOwnProperty("page") &&
          CP.basicChecker(urlParameters.page[0])
            ? urlParameters.page[0]
            : 1;
        if (
          urlPageNum != filtzPageNum ||
          urlParameters.hasOwnProperty("page")
        ) {
          if (!currentFilters.hasOwnProperty("page")) {
            let temp = {};
            temp["page"] = [];
            $.extend(currentFilters, temp);
          }
          currentFilters.page[0] = filtzPageNum;
        }

        if (
          self.showPerPage &&
          (source == "per_page" || urlParameters.hasOwnProperty("per_page"))
        ) {
          let filtzPerPageNum = FJS.page.perPage;
          let urlPerPageNum =
            urlParameters.hasOwnProperty("per_page") &&
            CP.basicChecker(urlParameters.per_page[0])
              ? urlParameters.per_page[0]
              : "";
          if (!currentFilters.hasOwnProperty("per_page")) {
            let temp = {};
            temp["per_page"] = [];
            $.extend(currentFilters, temp);
          }
          currentFilters.per_page[0] = filtzPerPageNum;
        }

        if (
          self.showSort &&
          (source == "sort" || urlParameters.hasOwnProperty("sort_by"))
        ) {
          let sortBy = $(document)
            .find(self.sortElement)
            .val();
          if (!currentFilters.hasOwnProperty("sort_by")) {
            let temp = {};
            temp["sort_by"] = [];
            $.extend(currentFilters, temp);
          }
          currentFilters.sort_by[0] = sortBy;
        }

        if (templateName == "search") {
          if (
            urlParameters.hasOwnProperty("q") &&
            CP.basicChecker(urlParameters.q[0])
          ) {
            let searchString = urlParameters.q[0];
            if (!currentFilters.hasOwnProperty("q")) {
              let temp = {};
              temp["q"] = [];
              $.extend(currentFilters, temp);
            }
            currentFilters.q[0] = searchString;
          }
          if (
            urlParameters.hasOwnProperty("type") &&
            CP.basicChecker(urlParameters.type[0])
          ) {
            let typeString = urlParameters.type[0];
            if (!currentFilters.hasOwnProperty("type")) {
              let temp = {};
              temp["type"] = [];
              $.extend(currentFilters, temp);
            }
            currentFilters.type[0] = typeString;
          }
        }

        let newUrl = self.createFILTzURL(currentFilters);
        if (devMode) {
          console.log(" -- >> New URL is " + newUrl);
        }
        self.historyPusher(newUrl, currentFilters);
        // }, 250);
      }
      if (devMode) {
        console.log(" -- Exiting setURL");
      }
    } catch (ex) {
      errorCatcher(ex, "setURL");
    }
  };

  FH.historyPusher = function() {
    try {
      if (devMode) {
        console.log(" -- Entering historyPusher");
      }
      let self = this;

      let newUrl =
        arguments.length > 0 && typeof arguments[0] !== "undefined"
          ? "?" + arguments[0]
          : "?";
      let stateObj =
        arguments.length > 1 && typeof arguments[1] !== "undefined"
          ? arguments[1]
          : null;
      history.pushState(stateObj, null, newUrl);
      if (devMode) {
        console.log(" -- Exiting historyPusher");
      }
    } catch (ex) {
      errorCatcher(ex, "historyPusher");
    }
  };

  FH.getSideBarFilters = function() {
    try {
      let self = this;

      let selected_filters = {};
      $(self.sideBarElement)
        .find("." + filtzParentClass)
        .each(function(e) {
          let parent = $(this);
          let filter_key = parent.attr("filterkey");
          let encoded_filter_key = parent.attr("encodedfilterkey");
          parent.find("." + filtzChildClass).each(function(ev) {
            let child = $(this);
            let filter_val = child.attr("filter");
            let encoded_filter_val = child.attr("encodedfilter");
            let state = child.attr("filtzstate");
            if (
              CP.basicChecker(state) &&
              state == 1 &&
              CP.basicChecker(encoded_filter_val) &&
              CP.basicChecker(encoded_filter_key)
            ) {
              if (!selected_filters.hasOwnProperty(encoded_filter_key)) {
                let temp = {};
                temp[encoded_filter_key] = [];
                $.extend(selected_filters, temp);
              }
              selected_filters[encoded_filter_key].push(encoded_filter_val);
            }
          });
        });
      return selected_filters;
    } catch (ex) {
      errorCatcher(ex, "getSideBarFilters");
    }
  };

  FH.getUrlParameters = function() {
    try {
      if (devMode) {
        console.log(" -- Entering getUrlParameters");
      }
      let self = this;

      let url_holder = {};
      let cur_url = decodeURIComponent(
        encodeURIComponent(window.location.href)
      );
      if (cur_url.indexOf("?") !== -1) {
        let url_parameters = cur_url.split("?");
        if (CP.basicChecker(url_parameters[1])) {
          let url_params = url_parameters[1];
          if (url_params.indexOf("&") !== -1) {
            let all_urls = url_params.split("&");
            all_urls.forEach(function(element) {
              let details = self.splitURLSects(element);
              let key__ = encodeURIComponent(
                CP.splitAndTrimAndLower(
                  decodeURIComponent(details.key).toLowerCase()
                )
                  .split("_")
                  .join("-")
              );
              let val__ = encodeURIComponent(
                CP.splitAndTrimAndLower(
                  decodeURIComponent(details.value).toLowerCase()
                )
                  .split("_")
                  .join("-")
              );
              if (CP.basicChecker(key__) && CP.basicChecker(val__)) {
                if (!url_holder.hasOwnProperty(key__)) {
                  let temp_obj = {};
                  temp_obj[key__] = [];
                  $.extend(url_holder, temp_obj);
                }
                url_holder[key__].push(val__);
              }
            });
          } else {
            let details = self.splitURLSects(url_params);
            let key__ = encodeURIComponent(
              CP.splitAndTrimAndLower(
                decodeURIComponent(details.key).toLowerCase()
              )
                .split("_")
                .join("-")
            );
            let val__ = encodeURIComponent(
              CP.splitAndTrimAndLower(
                decodeURIComponent(details.value).toLowerCase()
              )
                .split("_")
                .join("-")
            );
            if (CP.basicChecker(key__) && CP.basicChecker(val__)) {
              if (!url_holder.hasOwnProperty(key__)) {
                let temp_obj = {};
                temp_obj[key__] = [];
                $.extend(url_holder, temp_obj);
              }
              url_holder[key__].push(val__);
            }
          }
        }
      }
      if (devMode) {
        console.log(" -- Exiting getUrlParameters");
      }
      return url_holder;
    } catch (ex) {
      errorCatcher(ex, "getUrlParameters");
    }
  };

  FH.splitURLSects = function(ele) {
    try {
      let self = this;

      let ret_val = { key: "", value: "" };
      if (ele.indexOf("=") !== -1) {
        let url_block = ele.split("=");
        if (CP.basicChecker(url_block[0]) && CP.basicChecker(url_block[1])) {
          let key__ = url_block[0];
          let val__ = url_block[1];
          ret_val.key = key__;
          ret_val.value = val__;
        }
      }
      return ret_val;
    } catch (ex) {
      errorCatcher(ex, "splitURLSects");
    }
  };

  FH.createFILTzURL = function(holder) {
    try {
      let self = this;

      let new_urls = [];
      for (let key1 in holder) {
        let values = holder[key1];
        values.forEach(function(element) {
          new_urls.push(key1 + "=" + element);
        });
      }
      let new_url = new_urls.join("&");
      return new_url;
    } catch (ex) {
      errorCatcher(ex, "createFILTzURL");
    }
  };

  FH.showFILTzPagination = function() {
    try {
      if (devMode) {
        console.log(" -- Entering showFILTzPagination");
      }
      let self = this;

      $(document)
        .find(self.liquidPaginationElement)
        .hide();
      $(document)
        .find(self.filtzPaginationElement)
        .show();
      $(document)
        .find(self.filtzPaginationElement)
        .attr("style", "display: block !important");
      if (devMode) {
        console.log(" -- Exiting showFILTzPagination");
      }
    } catch (ex) {
      errorCatcher(ex, "showFILTzPagination");
    }
  };

  FH.renderActiveFilter = function(filters) {
    try {
      if (devMode) {
        console.log(" -- Entering renderActiveFilter");
      }
      let self = this;

      $(self.activeFilterObj.placeHolder).html("");
      if (jQuery.isEmptyObject(filters)) {
        $(self.activeFilterObj.container).hide();
      } else {
        for (let m in filters) {
          if (CP.basicChecker(m) && CP.basicChecker(filters[m])) {
            let temp = filters[m];
            if (CP.basicChecker(temp.header_name)) {
              let h_key = m;
              let h_name = temp.header_name;
              if (CP.basicChecker(temp.sub_menus)) {
                for (let n in temp.sub_menus) {
                  if (CP.basicChecker(n) && temp.sub_menus[n]) {
                    let m_key = n;
                    let m_name = temp.sub_menus[n];
                    let html_ = self.activeFilterObj.element;
                    html_ = CP.stringReplace(
                      html_,
                      "@af_filter_header",
                      h_name.toString()
                    );
                    html_ = CP.stringReplace(
                      html_,
                      "@af_filter_value",
                      m_name.toString()
                    );
                    html_ = CP.stringReplace(
                      html_,
                      "@af_header",
                      h_key.toString()
                    );
                    html_ = CP.stringReplace(
                      html_,
                      "@af_value",
                      m_key.toString()
                    );
                    $(self.activeFilterObj.placeHolder).append(html_);
                  }
                }
              }
            }
          }
        }
        $(self.activeFilterObj.container).show();
        self.activateAFCloseButtons();
      }
      if (devMode) {
        console.log(" -- Exiting renderActiveFilter");
      }
    } catch (ex) {
      errorCatcher(ex, "renderActiveFilter");
    }
  };

  FH.activateAFCloseButtons = function() {
    try {
      if (devMode) {
        console.log(" -- Entering activateAFCloseButtons");
      }
      let self = this;

      let parent_counter = 0;
      let child_counter = 0;
      $("." + self.activeFilterObj.closeButtonClass)
        .off("click")
        .on("click", function(ev) {
          let c_btn = $(this);
          let af_header = c_btn.attr("af_header");
          let af_value = c_btn.attr("af_value");
          let clicker = false;

          $("." + filtzParentClass).each(function() {
            let parent = $(this);
            if (parent.attr("encodedfilterkey") == af_header) {
              parent.find("." + filtzChildClass).each(function() {
                let child = $(this);
                if (
                  child.attr("encodedfilter") == af_value &&
                  child.attr("filtzstate") == "1"
                ) {
                  child.trigger("click");
                }
              });
            }
          });
        });
      if (devMode) {
        console.log(" -- Exiting activateAFCloseButtons");
      }
    } catch (ex) {
      errorCatcher(ex, "activateAFCloseButtons");
    }
  };

  FH.clearAllFilters = function() {
    try {
      if (devMode) {
        console.log(" -- Entering clearAllFilters");
      }
      let self = this;

      let last_ele = $(self.sideBarElement)
        .find("." + filtzChildClass + "[filtzstate='1']")
        .last();
      $(self.sideBarElement)
        .find("." + filtzChildClass + "[filtzstate='1']")
        .each(function(index, value) {
          let child = $(this);
          if (child[0] == last_ele[0]) {
            child.trigger("click");
          } else {
            child.attr("filtzstate", "0");
            child.removeClass(self.permanentToggleClass);
            if (self.toggleClass) {
              child.toggleClass(self.toggleClass);
            }
          }
        });
      if (devMode) {
        console.log(" -- Exiting clearAllFilters");
      }
    } catch (ex) {
      errorCatcher(ex, "clearAllFilters");
    }
  };

  FH.bindCommonEvents = function() {
    try {
      if (devMode) {
        console.log(" -- Entering bindCommonEvents");
      }
      let self = this;

      if (
        self.activeFilter &&
        CP.basicChecker(self.activeFilterObj.clearAllElement)
      ) {
        $(self.activeFilterObj.clearAllElement)
          .off("click")
          .on("click", function(e) {
            e.preventDefault();
            self.clearAllFilters();
          });
      }

      if (self.showSort) {
        self.initiateSort();
      }

      if (self.clearAllElement) {
        $(self.clearAllElement)
          .off("click")
          .on("click", function(e) {
            e.preventDefault();
            self.clearAllFilters();
          });
      }

      window.addEventListener("popstate", function() {
        self.isPopStateEvent = true;
        let currentFilters = self.getUrlParameters();
        if (!currentFilters.hasOwnProperty("page")) {
          let temp = {};
          temp["page"] = [1];
          $.extend(currentFilters, temp);
        }
        $.when(currentFilters).done(function() {
          self.applyFiltersFromObject(currentFilters);
        });
      });
      if (devMode) {
        console.log(" -- Exiting bindCommonEvents");
      }
    } catch (ex) {
      errorCatcher(ex, "bindCommonEvents");
    }
  };

  FH.initiateSort = function() {
    try {
      if (devMode) {
        console.log(" -- Entering initiateSort");
      }
      let self = this;

      $(document)
        .find(self.sortElement)
        .change(function(e) {
          self.currentSort = $(this).val();
          self.processSort();
        });
      if (devMode) {
        console.log(" -- Exiting initiateSort");
      }
    } catch (ex) {
      errorCatcher(ex, "initiateSort");
    }
  };

  FH.processSort = function() {
    try {
      if (devMode) {
        console.log(" -- Entering processSort");
      }
      let self = this;

      self.preFilter();
      let products = [];
      switch (self.currentSort) {
        case "manual":
          products = sortResults(self.allProducts, "MNL", true);
          break;

        case "best-selling":
          products = sortResults(self.allProducts, "BST", true);
          break;

        case "title-ascending":
          products = sortResults(self.allProducts, "T", true);
          break;

        case "title-descending":
          products = sortResults(self.allProducts, "T", false);
          break;

        case "price-ascending":
          products = sortResults(self.allProducts, "P", true);
          break;

        case "price-descending":
          products = sortResults(self.allProducts, "P", false);
          break;

        case "created-ascending":
          products = sortResults(self.allProducts, "CAT", true);
          break;

        case "created-descending":
          products = sortResults(self.allProducts, "CAT", false);
          break;

        default:
          products = sortResults(self.allProducts, "ORD", true);
          break;
      }
      let replaceRecords = self.replaceRecords(products);
      $.when(replaceRecords).done(function() {
        self.setURL("sort");
      });
      if (devMode) {
        console.log(" -- Exiting processSort");
      }
    } catch (ex) {
      errorCatcher(ex, "processSort");
    }
  };

  FH.replaceRecords = function(products) {
    try {
      if (devMode) {
        console.log(" -- Entering replaceRecords");
      }
      let self = this;

      FJS.removeRecords({});
      FJS.addRecords(products);
      if (devMode) {
        console.log(" -- >> Data replaced for FILTz");
        console.log(" -- Exiting replaceRecords");
      }
    } catch (ex) {
      errorCatcher(ex, "replaceRecords");
    }
  };

  FH.checkModel = function() {
    try {
      if (devMode) {
        console.log(" -- Entering checkModel");
      }
      let self = this;

      if (
        parseInt(FJS.Model.records.length) !== parseInt(self.allProducts.length)
      ) {
        if (devMode) {
          console.log(
            " -- >> Since records length are different, Going to replace data"
          );
        }
        self.replaceRecords(self.allProducts);
      }
      if (devMode) {
        console.log(" -- Exiting checkModel");
      }
    } catch (ex) {
      errorCatcher(ex, "checkModel");
    }
  };

  FH.applyFiltersFromObject = function(filters) {
    try {
      if (devMode) {
        console.log(" -- Entering applyFiltersFromObject");
      }
      let self = this;

      let pageNum = false;
      let perPage = false;
      let sortBy = false;

      if (filters.hasOwnProperty("page") && CP.basicChecker(filters.page[0])) {
        if (FJS.page.currentPage != filters.page[0]) {
          pageNum = filters.page[0];
        }
      }

      if (self.showPerPage) {
        if (
          filters.hasOwnProperty("per_page") &&
          CP.basicChecker(filters.per_page[0])
        ) {
          if (FJS.page.perPage != filters.per_page[0]) {
            perPage = filters.per_page[0];
          }
        } else {
          if (FJS.page.perPage != self.perPageValues[0]) {
            perPage = self.perPageValues[0];
          }
        }
      }

      if (self.showSort) {
        if (
          filters.hasOwnProperty("sort_by") &&
          CP.basicChecker(filters.sort_by[0])
        ) {
          if (self.currentSort && filters.sort_by[0] != self.currentSort) {
            sortBy = filters.sort_by[0];
          }
        } else {
          sortBy = CP.basicChecker($("#__sr__").val())
            ? $("#__sr__").val()
            : defaultOrder;
          if (self.currentSort == sortBy) {
            sortBy = false;
          }
        }
      }

      let sideBarClicked = self.triggerSideBarFilters(filters);
      $.when(sideBarClicked).done(function() {
        if (sortBy) {
          if (devMode) {
            console.log(
              " -- >> Found sort " +
                self.sortElement +
                " in applyFiltersFromObject() to be clicked"
            );
          }
          $(document)
            .find(self.sortElement)
            .val(sortBy)
            .change();
        }

        if (perPage) {
          if (devMode) {
            console.log(
              " -- >> Found per page " +
                self.actualPerPageElement +
                " in applyFiltersFromObject() to be clicked"
            );
          }
          $(document)
            .find(self.actualPerPageElement)
            .val(perPage)
            .change();
        }

        if (pageNum) {
          if (devMode) {
            console.log(
              " -- >> Found page " +
                pageNum +
                " in applyFiltersFromObject() to be clicked"
            );
          }
          PG.setCurrentPage(pageNum);
          PG.currentPage = pageNum;
        }

        self.isPopStateEvent = false;
      });

      if (devMode) {
        console.log(" -- Exiting applyFiltersFromObject");
      }
    } catch (ex) {
      errorCatcher(ex, "applyFiltersFromObject");
    }
  };

  FH.triggerSideBarFilters = function(filters) {
    try {
      if (devMode) {
        console.log(" -- Entering triggerSideBarFilters");
      }
      let self = this;

      if (jQuery.isEmptyObject(filters)) {
        self.clearAllFilters();
      } else {
        $(self.sideBarElement)
          .find("." + filtzParentClass)
          .each(function() {
            let parent = $(this);
            let parentKeyEncoded = parent.attr("encodedfilterkey");
            if (CP.basicChecker(parentKeyEncoded)) {
              parent.find("." + filtzChildClass).each(function(e) {
                let child = $(this);
                let childKeyEncoded = child.attr("encodedfilter");
                let isInFilter =
                  filters.hasOwnProperty(parentKeyEncoded) &&
                  filters[parentKeyEncoded].indexOf(childKeyEncoded) !== -1
                    ? true
                    : false;
                if (CP.basicChecker(childKeyEncoded)) {
                  let state = parseInt(child.attr("filtzstate"));
                  if (state == 1) {
                    if (!isInFilter) {
                      child.trigger("click");
                    }
                  } else {
                    if (isInFilter) {
                      child.trigger("click");
                    }
                  }
                }
              });
            }
          });
      }
      if (devMode) {
        console.log(" -- Exiting triggerSideBarFilters");
      }
      return true;
    } catch (ex) {
      errorCatcher(ex, "triggerSideBarFilters");
    }
  };

  FH.applyFILTzFromURL = function() {
    try {
      if (devMode) {
        console.log(" -- Entering applyFILTzFromURL");
      }
      let self = this;

      let urlParameters = self.getUrlParameters();
      let blockedKeys = ["page", "sort_by", "q"];
      if (templateName == "search") {
        blockedKeys.push("type");
      }
      let parameterKeys = Object.keys(urlParameters);
      let newKeys = [];
      parameterKeys.forEach(function(ele) {
        if (blockedKeys.indexOf(ele) == -1) {
          newKeys.push(ele);
        }
      });
      if (newKeys.length > 0) {
        if (devMode) {
          console.log(" -- >> Parameters to be applied are ", urlParameters);
        }
        self.applyFiltersFromObject(urlParameters);
      }
      if (devMode) {
        console.log(" -- Exiting applyFILTzFromURL");
      }
    } catch (ex) {
      errorCatcher(ex, "applyFILTzFromURL");
    }
  };

  FH.wrapUpFunctions = function() {
    let self = this;
    // $('#SortBy').closest('.filters-toolbar__box').find('.filters-toolbar__label').text(defaultOrder);
     //$('#SortBy').change(function(e){
       //let sortVal = $( "#SortBy option:selected" ).text();
       //$(this).closest('.filters-toolbar__box').find('.filters-toolbar__label').text(sortVal);
   // });
  };

  FH.afterProductsRendered = debounce(function() {
    let self = this;

    if (self.filterAppliedCount > 0) {
      afterProductsDisplayed();
    }
  }, 200);
})(jQuery, window, document);
